import React, { Component } from 'react';
import {
View,
  Text,ListView,TextInput,
  ScrollView,TouchableHighlight,FlatList,Dimensions, Image,Linking, Alert,Platform, ActivityIndicator,Clipboard,Animated,
} from 'react-native';
import {StyleContext, styleInfo} from '../styleC';

import MavButton from './mavButton';

import firebase from './firebase';
import { getAuth } from "firebase/auth";
import { getDatabase, ref, set, update, remove, get, onValue, child, orderByChild, orderByValue, limitToFirst, startAt, endAt, query} from "firebase/database";

import strings from '../strings';
import example from '../example';
import info from '../info';
import karhooPartner from '../karhooPartner';
const timer = require('react-native-timer');
import MavSelectDate from './mavSelectDate';
import MapView from './mapView';
import MavAlert from './mavAlert';
import moneyList from '../moneyList';
import countryList from '../countryList';
import MavQRCode from './mavQRCode';
import Geolocation from './geolocalisation';
import Chat from './chat';
import GenerateBill from './generateBill';
import Modal from './modal';
import Qs from 'qs';
import CommonActions from "./CommonActions";
import HelpRace from './helpRace';
import SncfInfo from './sncfInfo';
import TextPresentation from './textPresentation';

import ManageOptions from './manageOptions';
import FlightInfo from './flightInfo';

import Trajet from './trajet';
import MavMiniButton from './mavMiniButton';
import RaceTrajetInfo from './raceTrajetInfo';

var mobileBrand={
  "APPLE":{icon:require('../assets/mobile/apple.png') },
  "SAMSUNG":{icon:require('../assets/mobile/samsung.png') },
  "XIAOMI":{icon:require('../assets/mobile/xiaomi.png') },
  "OPPO":{icon:require('../assets/mobile/oppo.png') },
  "VIVO":{icon:require('../assets/mobile/vivo.png') },
  "GOOGLE":{icon:require('../assets/mobile/google.png') },
  

}







export default class App extends Component {
  constructor(props) {
    super(props);

    var params=(this.props.route!=undefined)?this.props.route.params:this.props;    

    

    if(Platform.OS!="web") this.props.navigation.setOptions({title:strings.raceNumber+" "+params.data.id.split('-')[0] }); 


    var i; 
    var pushInfo
    var partnerListProv=[];
    var partnerList=[];
    if(params.data.desiredDriver!=undefined){
      partnerListProv=(params.data.desiredDriver!=undefined && params.data.desiredDriver.other!=undefined)?params.data.desiredDriver.other:[]; 
      for(i=0; i<partnerListProv.length;i++){ if(partnerListProv[i].id!=-1 && partnerListProv[i].id!="-1") { 
        pushInfo=partnerListProv[i];
        if(params.data.desiredDriverDecline!=undefined && params.data.desiredDriverDecline[partnerListProv[i].id]!=undefined && params.data.desiredDriverDecline[partnerListProv[i].id].decline==true) pushInfo.textSmall="("+strings.initialyDecline+")"
        partnerList.push(pushInfo); 

        

      } }

    }
    partnerList.push({id:-1, text:"Chercher d'autres chauffeurs"})

    /*if(params.data.desiredDriver==undefined && (params.driver==true || (params.partner==true && params.privilegeDriver=="max")  )) this.getPartnersList();
    */
    var date=new Date(params.data.raceDate)
    date=((date.getDate()<10)?"0":"")+date.getDate()+"/"+(((date.getMonth()+1)<10)?"0":"")+(date.getMonth()+1)+" - "+((date.getHours()<10)?"0":"")+date.getHours()+":"+((date.getMinutes()<10)?"0":"")+date.getMinutes()
    var attrib=(params.data.attributedPartner!=undefined)?params.data.attributedPartner:{id:"",text:strings.notDefined}
    
    


    var attribCar=(params.data.attributedPartner!=undefined && params.data.attributedPartner.car!=undefined )?params.data.attributedPartner.car:undefined;
    
    /* On attribue une voiture si c'est ma course et que personne n'a défini de voiture */
    if(attribCar==undefined && params.data.attributedPartner!=undefined && params.data.attributedPartner.id==getAuth(firebase).currentUser.uid){
        if(params.actualUserCar!=undefined){
          var listAUC=Object.keys(params.actualUserCar) 
          attribCar=params.actualUserCar[listAUC[0]];

          const fireInfo={} 
          fireInfo['race/' +params.data.id+"/attributedPartner/car"]=attribCar; 
          update(ref(getDatabase(firebase)), fireInfo)

          if(params.updateData!=undefined){
            timer.setTimeout("timer3", () => {params.updateData()}, 2000);
          }
        }
    } 

    var actualUserCar=[];
    var i;
    if(params.actualUserCar!=undefined){
      var listAUC=Object.keys(params.actualUserCar)

      for(i=0;i<listAUC.length;i++){
          actualUserCar.push({id:listAUC[i], text:params.actualUserCar[listAUC[i]].brand+" "+params.actualUserCar[listAUC[i]].model })
      }
    }



    var driverPrice;
    var moneyID=(params.data.moneyID!=undefined)?params.data.moneyID:"eu";
    var money=this.findMoney(moneyID)
    var hideDriverPrice=undefined; 
    console.log(params.driver+"!=true"+" && "+params.pricingView.hidePriceRaceForDriver+"==true")
    if(params.driver!=true && params.pricingView.hidePriceRaceForDriver==true && ( (params.data.charge!=undefined && params.data.capture!="stripeError") || params.data.alreadyPaid==true || params.data.deferredPayment==true || params.data.karhooProvider==true  )  ) hideDriverPrice=true;


      if(params.data.letaxiProvider!=true && ((params.billMode=="double" || ( (params.data.charge!=undefined || params.data.deferredPayment==true || params.data.karhooProvider==true) && params.billMode=="partnerCompany")))){
        var price=params.data.estimatePrice;

        var moneyID=(params.data.moneyID!=undefined)?params.data.moneyID:"eu";
        if(moneyID!="eu") money=this.findMoney(moneyID)
        price=price.replace(money.symbole,'')
        var n = price.indexOf("-");
        if(n!=-1) {
          var price1=parseFloat(price.substring(0,n))
          var price2=parseFloat(price.substring(n+1,price.length))
          if(params.data.addDriverPrice!=undefined) {price1+=params.data.addDriverPrice; price2+=params.data.addDriverPrice; } 


          if(params.pricingView.addCommissionFixe===true && params.pricingView.addCommissionFixeAmount>0){ price1-=params.pricingView.addCommissionFixeAmount;price2-=params.pricingView.addCommissionFixeAmount;}
          if(params.pricingView.addCommissionVariable===true && params.pricingView.addCommissionVariableAmount>0) {price1=price1*((100-params.pricingView.addCommissionVariableAmount)/100);price2=price2*((100-params.pricingView.addCommissionVariableAmount)/100);}
          if(params.pricingView.commissionDriver>0) {price1=price1*((100-params.pricingView.commissionDriver)/100);price2=price2*((100-params.pricingView.commissionDriver)/100);}
          price1=price1.toFixed(2);
          price2=price2.toFixed(2);
          driverPrice=price1+"-"+price2;


        }else{
          driverPrice=parseFloat(price);
          if(params.data.addDriverPrice!=undefined) {driverPrice+=params.data.addDriverPrice; } 
          if(params.pricingView.addCommissionFixe===true && params.pricingView.addCommissionFixeAmount>0) driverPrice-=params.pricingView.addCommissionFixeAmount;
          if(params.pricingView.addCommissionVariable===true && params.pricingView.addCommissionVariableAmount>0) driverPrice=driverPrice*((100-params.pricingView.addCommissionVariableAmount)/100);
          if(params.pricingView.commissionDriver>0) driverPrice=driverPrice*((100-params.pricingView.commissionDriver)/100);
          driverPrice=driverPrice.toFixed(2);
        }
        if(params.data.forceDriverPrice!=undefined) driverPrice=params.data.forceDriverPrice;
        driverPrice=((money.position=="left")?(money.symbole+" "):"")+driverPrice+((money.position=="right")?(money.symbole):"");
      }
      else {
        driverPrice=params.data.estimatePrice;        
      }

      if(driverPrice!=undefined && driverPrice!=params.data.estimatePrice && params.driver!=true && params.data.driverPrice==undefined) {
          const fireInfo={} 
          fireInfo['race/' + params.data.id+"/driverPrice"]=driverPrice;
          update(ref(getDatabase(firebase)), fireInfo)
      }


      var gmbLink="";
      if(params.activateGoogleMyBusiness==true){
          var idLanguage=(params.data.languageID!=undefined)?params.data.languageID:"fr";
          var text=params.googleMyBusinessText[idLanguage];
          if(text==undefined) params.googleMyBusinessText["fr"];
          if(text==undefined) text="";
          text = text.split('%NAME%').join(params.data.clientName)
          text = text.split('%LASTNAME%').join(params.data.clientLastName)
          text = text.split('%DATE%').join(date)

          text = text.split('%START%').join(params.data.racePlaceStartName)
          text = text.split('%END%').join(params.data.racePlaceEndName)

          text = text.split('%DRIVER%').join(attrib.text)

          gmbLink=text;
      }
      var numero=params.data.clientPhone;
      var result=this.findPhoneIID(params.data.clientPhone)
      if(result!=undefined && result.idd!=undefined && params.data.clientPhone!=undefined){
        if(numero[0]=="+" && result.idd!="+39" && numero[result.idd.length]=="0" ) numero=result.idd+numero.slice(result.idd.length+1,numero.length)
        else if(numero[0]=="0" && numero[1]=="0" && result.idd!="+39" && numero[result.idd.length+1]=="0" ) numero=result.idd+numero.slice(result.idd.length+2,numero.length)
      }
      

       console.log(params.raceProviderMode)

       var originalPrice=this.calculateInitalOptionFee((params.data.letaxiProvider!=true)?params.data.estimatePrice:0, params.data.selectedOptions, money)
    

    this.state={
          seeGenerateBill:false,
          money:money,
          viewD:params.data.viewD,
          waitConfirmRace:params.data.waitConfirmRace,
          params:params,
          gmbLink:gmbLink, 
          saveRemovedRace:params.saveRemovedRace,
          actualUserLastName:params.actualUserLastName,
          actualUserName:params.actualUserName,
          modify:params.data.modify,
          doubt:params.data.doubt,
          noVAT:params.data.noVAT,
          seeHelpRace:false,
          hideDriverPrice:hideDriverPrice,
          addDriverPrice:params.data.addDriverPrice,
          clientNote:params.data.clientNote,
          driver:params.driver,
          partner:params.partner,
          actualUserCar:actualUserCar,
          privilegeDriver:params.privilegeDriver,
          viewPhone:params.viewPhone,
          car:attribCar,
          racePlaceStartName:params.data.racePlaceStartName,
          racePlaceEndName:params.data.racePlaceEndName,
          racePlaceEndNameTest:params.data.racePlaceEndName,
          numTrain:params.data.numTrain,
          numFlight:params.data.numFlight,
          stopList:params.data.stopList,
          passagers:params.data.passagers, 
          passagersList:(params.data.passagersList!=undefined)?params.data.passagersList:[],
          luggage:params.data.luggage, 
          providerBill:params.data.providerBill,
          paymentDriverMode:params.data.paymentDriverMode,
          clientName:params.data.clientName,
          karhooAccountID:params.data.karhooAccountID, 
          description:params.data.description,
          carName:params.data.carName,
          clientID:params.data.clientID,
          clientLastName:params.data.clientLastName,
          clientPhone:numero,
          clientEmail:params.data.clientEmail,
          clientEnterprise:params.data.clientEnterprise,
          status:params.data.status,
          estimatePrice:params.data.estimatePrice,
          originalPrice:originalPrice,
          driverPrice:driverPrice,
          charge:params.data.charge,
          chargeAfterRace:params.data.chargeAfterRace,
          deferredPayment:params.data.deferredPayment,
          withMyPOS:params.data.withMyPOS,
          notBill:params.data.notBill,
          deferredPaymentID:params.data.deferredPaymentID,
          estimateTimeValue:params.data.estimateTimeValue,
          raceDate:params.data.raceDate,
          finalPriceDriverTTC:params.data.finalPriceDriverTTC,
          date:date,
          karhooProvider:params.data.karhooProvider,
          letaxiProvider:params.data.letaxiProvider, 
          viaAPI:params.data.viaAPI,
          driverPosition:{},
          raceInProgress:params.data.raceInProgress,
          noShow:params.data.noShow, 
          vip:(params.data.vip==true)?true:false,
          estimateKm:params.data.estimateKm,
          desiredDriverDecline:params.data.desiredDriverDecline,
          id:params.data.id,
          orderDate:params.data.orderDate,
          createClientAlready:(params.data.createClientAlready!=undefined)?params.data.createClientAlready:false,
          providerID:(params.data.apiID!=undefined)?params.data.apiID:params.data.providerID,
          customerPro:params.data.customerPro, 
          providerName:(params.data.customerProName!=undefined)?params.data.customerProName:params.data.providerName,
          providerEmail:(params.data.customerProEmail!=undefined)?params.data.customerProEmail:params.data.providerEmail,
          providerLastName:(params.data.customerProLastName!=undefined)?params.data.customerProLastName:params.data.providerLastName,
          providerEnterprise:(params.data.customerProEnterprise!=undefined)?params.data.customerProEnterprise:params.data.providerEnterprise,
          desiredDriver:params.data.desiredDriver,
          alreadyPaid:params.data.alreadyPaid,
          userRequestAnnulation:(params.data.userRequestAnnulation!=undefined)?params.data.userRequestAnnulation:false,
          attributedPartner:attrib,
          companyBrand:info.companyBrand,
          selectedOptions:params.data.selectedOptions,
          companyAdress:info.companyAdress,
          companyCity:info.companyCity,
          companyPhone:info.companyPhone,
          companyEmail:info.companyEmail,
          taxiMode:params.data.taxiMode,
          goReturnTaxi:params.data.goReturnTaxi,
          priceNetForDriver:(params.pricingView!=undefined && params.pricingView.priceNetForDriver==true)?true:false,
          hidePriceRaceForDriver:(params.pricingView!=undefined && params.pricingView.hidePriceRaceForDriver==true)?true:false,
          markers:[],
          cpam:params.data.cpam,
          viewPrincipalCustomer:false,
          viewKarhooForDrivers:(params.viewKarhooForDrivers==true)?true:false, 
          viewPartnerForDrivers:(params.viewPartnerForDrivers==true)?true:false, 
          coords:[],
          partnerList:partnerList,
          search:"",
          waitingLink:false, 
          removeOption:params.removeOption, 
          seeChat:false,
          driverPlaceInfoAdmin:(params.data.forceDriverPrice!=undefined)?((money.position=="left")?(money.symbole+" "):"")+params.data.forceDriverPrice+((money.position=="right")?(money.symbole):""): (   (params.driver==true && params.data.driverPrice!=undefined)?params.data.driverPrice:((params.driver==true)?false:undefined) ) , 
          forceDriverPrice:(params.data.forceDriverPrice!=undefined)?((money.position=="left")?(money.symbole+" "):"")+params.data.forceDriverPrice+((money.position=="right")?(money.symbole):""):undefined,
        
          customerProName:params.data.customerProName,
          customerProEmail:params.data.customerProEmail,
          customerProLastName:params.data.customerProLastName,
          customerProEnterprise:params.data.customerProEnterprise,
          customerProAdressBill:params.data.customerProAdressBill,
          customerProCityBill:params.data.customerProCityBill,
          providerAdressBill:params.data.providerAdressBill,
          providerCityBill:params.data.providerCityBill,
          clientAdressBill:params.data.clientAdressBill,
          clientCityBill:params.data.clientCityBill,
          raceProviderMode:params.data.raceProviderMode,
          driverMessage:params.data.driverMessage,
          changeFromHelp:false,
          missingRace:false, 
          viewClientDetail:false,
          viewEditDescription:false,




        } 







      this.getDriverPosition();
      if(Platform.OS!="web") this.calculateMaps();

      timer.setInterval("timer", () => {
        var params=(this.props.route!=undefined)?this.props.route.params:this.props; 

        if(this.state.change==true){
          this.setState({change:false})

          if(this.state.attributedPartner!=undefined && this.state.attributedPartner.id!=getAuth(firebase).currentUser.uid && this.state.driver==true)  this.setState({purposeChange:true})


          const fireInfo={} 
          if(this.state.letaxiProvider!=true) fireInfo['race/' + this.state.id+"/estimateTimeValue"]=this.state.estimateTimeValue;
          fireInfo['race/' + this.state.id+"/racePlaceStartName"]=this.state.racePlaceStartName;
          fireInfo['race/' + this.state.id+"/raceDate"]=this.state.raceDate;
          if(this.state.letaxiProvider!=true) fireInfo['race/' + this.state.id+"/carName"]=this.state.carName;
          var raceDate=new Date(this.state.raceDate)
          raceDate=((raceDate.getDate()<10)?"0":"")+raceDate.getDate()+"/"+(((raceDate.getMonth()+1)<10)?"0":"")+(raceDate.getMonth()+1)+"/"+raceDate.getFullYear()+" - "+((raceDate.getHours()<10)?"0":"")+raceDate.getHours()+":"+((raceDate.getMinutes()<10)?"0":"")+raceDate.getMinutes()
          fireInfo['race/' + this.state.id+"/raceDateFixed"]=raceDate;


          if(this.state.letaxiProvider!=true) fireInfo['race/' + this.state.id+"/estimatePrice"]=this.state.estimatePrice;
           if(this.state.description!=undefined) fireInfo['race/' + this.state.id+"/description"]=this.state.description;
          if(this.state.letaxiProvider!=true) fireInfo['race/' + this.state.id+"/clientName"]=(this.state.clientName!=undefined)?this.state.clientName:null
          if(this.state.letaxiProvider!=true) fireInfo['race/' + this.state.id+"/clientLastName"]=(this.state.clientLastName!=undefined)?this.state.clientLastName:null
          
          if(this.state.passagers!=undefined) fireInfo['race/' + this.state.id+"/passagers"]=this.state.passagers
          if(this.state.clientPhone!=undefined && this.state.clientPhone!="") fireInfo['race/' + this.state.id+"/clientPhone"]=this.state.clientPhone

          if(this.state.selectedOptions!=undefined) {
            if(this.state.selectedOptions=={}) fireInfo['race/' + this.state.id+"/selectedOptions"]=null;
            else fireInfo['race/' + this.state.id+"/selectedOptions"]=this.state.selectedOptions
          }
            
          if(this.state.numFlight!=undefined) fireInfo['race/' + this.state.id+"/numFlight"]=this.state.numFlight
          if(this.state.numTrain!=undefined) fireInfo['race/' + this.state.id+"/numTrain"]=this.state.numTrain
          if(( this.state.stopList!=undefined && this.state.stopList.length==0) || this.state.racePlaceEndName==undefined) fireInfo['race/' + this.state.id+"/stopList"]=null
          else if(this.state.stopList!=undefined) fireInfo['race/' + this.state.id+"/stopList"]=this.state.stopList

          if(this.state.passagersList!=undefined && this.state.passagersList.length!=0) fireInfo['race/' + this.state.id+"/passagersList"]=this.state.passagersList;
          else fireInfo['race/' + this.state.id+"/passagersList"]=null

          if(this.state.racePlaceEndName!=undefined) fireInfo['race/' + this.state.id+"/racePlaceEndName"]=this.state.racePlaceEndName; 



          if(this.state.changeFromHelp==true){
              if(this.state.changeDeferredID==true) {fireInfo['race/' + this.state.id+"/deferredPaymentID"]=null; this.setState({changeDeferredID:false}) }
              
              fireInfo['race/' + this.state.id+"/estimateKm"]=(this.state.estimateKm==undefined)?null:this.state.estimateKm;
              fireInfo['race/' + this.state.id+"/status"]=this.state.status
              if(this.state.racePlaceEndName==undefined) fireInfo['race/' + this.state.id+"/racePlaceEndName"]=null;

              if(this.state.charge!=undefined && this.state.charge.alreadyCharge==true) fireInfo['race/' + this.state.id+"/charge"]=this.state.charge
              this.setState({changeFromHelp:false})
          }

          if(this.state.driver==true && this.state.providerID!=undefined && this.state.status=="validate" && this.state.deferredPayment!=true){
            if(this.state.providerName!=undefined) fireInfo['race/' + this.state.id+"/providerName"]=this.state.providerName;
            if(this.state.providerLastName!=undefined) fireInfo['race/' + this.state.id+"/providerLastName"]=this.state.providerLastName;
            if(this.state.providerEnterprise!=undefined) fireInfo['race/' + this.state.id+"/providerEnterprise"]=(this.state.providerEnterprise!=undefined && this.state.providerEnterprise!="")?this.state.providerEnterprise:null;
            
            if(this.state.providerBill==true){
              fireInfo['race/' + this.state.id+"/providerAdressBill"]=(this.state.providerAdressBill!=undefined && this.state.providerAdressBill!="")?this.state.providerAdressBill:null;
              fireInfo['race/' + this.state.id+"/providerCityBill"]=(this.state.providerCityBill!=undefined && this.state.providerCityBill!="")?this.state.providerCityBill:null;
            }
          }

          if(this.state.driver==true && this.state.customerPro==true && this.state.status=="validate" && this.state.deferredPayment!=true){
            fireInfo['race/' + this.state.id+"/customerProName"]=this.state.providerName;
            fireInfo['race/' + this.state.id+"/customerProLastName"]=this.state.providerLastName;
            fireInfo['race/' + this.state.id+"/customerProEnterprise"]=(this.state.providerEnterprise!=undefined && this.state.providerEnterprise!="")?this.state.providerEnterprise:null;
            
            if(this.state.providerBill==true){
              fireInfo['race/' + this.state.id+"/customerProAdressBill"]=(this.state.providerAdressBill!=undefined && this.state.providerAdressBill!="")?this.state.providerAdressBill:null;
              fireInfo['race/' + this.state.id+"/customerProCityBill"]=(this.state.providerCityBill!=undefined && this.state.providerCityBill!="")?this.state.providerCityBill:null;
            }
          }

          
          console.log(fireInfo)


          if((this.state.providerID!=undefined && this.state.providerID!="") || (this.state.clientID!=undefined && this.state.clientID!="")){
              var repOther=(this.state.providerID!=undefined && this.state.providerID!="")?('usersRace/' +this.state.providerID):('usersRace/' +this.state.clientID);
              

              for (const [key, value] of Object.entries(fireInfo)) {
                var keyN=key.replace('race', repOther)
                fireInfo[keyN]=value;
              }

          }

          update(ref(getDatabase(firebase)), fireInfo)


          
          var paramsB=(this.props.route!=undefined)?this.props.route.params:this.props; 
          paramsB.updateData(); 

          
        }
      }, 5000);






        }

        findMoney(value){
    if(value==undefined) value="eu";
    var final="";
    var i; 
    for(i=0;i<moneyList.length;i++){
      if(final==""){
        if(moneyList[i].id==value) final=moneyList[i];
      }
    }
    return final
  }

 

  decode(t, e) {
    for (
      var n,
        o,
        u = 0,
        l = 0,
        r = 0,
        d = [],
        h = 0,
        i = 0,
        a = null,
        c = Math.pow(10, e || 5);
      u < t.length;

    ) {
      (a = null), (h = 0), (i = 0);
      do
        (a = t.charCodeAt(u++) - 63), (i |= (31 & a) << h), (h += 5);
      while (a >= 32);
      (n = 1 & i ? ~(i >> 1) : i >> 1), (h = i = 0);
      do
        (a = t.charCodeAt(u++) - 63), (i |= (31 & a) << h), (h += 5);
      while (a >= 32);
      (o = 1 & i ? ~(i >> 1) : i >> 1), (l += n), (r += o), d.push([
        l / c,
        r / c,
      ]);
    }
    return (d = d.map(function(t) {
      return { latitude: t[0], longitude: t[1] };
    }));
  }

  getPartnersList(){
    console.log("je lance getPartnersList")
    var params=(this.props.route!=undefined)?this.props.route.params:this.props;     

    var body={
      uuid:getAuth(firebase).currentUser.uid
    }
    if(info.mavOffer=="multi"){
      body.carName=params.data.carName;
      body.viewAllPartners=true;
    }

   


    fetch("https://us-central1-"+info.firebaseProjectID+".cloudfunctions.net/getPartner", {
        body: JSON.stringify(body),
        headers: {"Content-Type": "application/json"},method: "POST"}).then((response) => response.json()).then((responseJson) => {
          var res=responseJson
          
          var res2=[]
          var res3=[]; 
          var i; 
          for(i=0;i<res.length;i++) {
            if(res[i].notCompatible==true) res3.push(res[i])
            else res2.push(res[i])          
          }

            res2 = res2.concat(res3);

          this.setState({})
          this.setState({partnerList:res2},() =>{this.viewPartner()})

          
          
        }).catch((err) => { console.log("error getPartnersList"); console.log(err); timer.setTimeout("getPartnersList", () => { this.getPartnersList();  }, 2000);   })
    }


  viewPDFFile(link){
    if(Platform.OS==="web") window.open(link, '_blank');
    else this.props.navigation.navigate("MavPDF",{mode:"viewer", url:link, title:strings.bill});
  }



  findPhoneIID(test){
    if(test!=undefined) test=test.replace("+","00")
    var final="";
    var i,j;
    var n;
    var list=Object.keys(countryList);
    for(i=0;i<list.length;i++){
      if(final==""){
          var testList=countryList[list[i]].list;
          for(j=0;j<testList.length;j++){ 
            if(test!=undefined){
              n=testList[j].idd.replace("+","00")
              n=test.search(n)
              if(n==0) final=testList[j]
            }
            else if(testList[j].id==info.countryCode) final=testList[j]
          }
      }
    }
    if(final=="") return {id:"fr",code:"+33"}
    else return {id:final.id,idd:final.idd, flag:final.flag}
    
  }


  sendWithSMS(message,phone,forceMode,disableClientInfo){
    phone=((phone==undefined)?this.state.clientPhone:phone);
    if(phone!=undefined){
         if(phone[0]=="+" && phone[1]==3 && phone[2]==3 && phone[3]==0) phone="+33"+phone.slice(4)
         else if (phone[0]==0 && info.countryCode=="fr") phone="+33"+phone.slice(1);
         else if(phone[0]=="+" && phone[1]==5 && phone[2]==9 && phone[3]==0 && phone[4]==0) phone="+590"+phone.slice(5)
         else if (phone[0]==0 && info.countryCode=="gp") phone="+590"+phone.slice(1);
    }
    console.log(phone)
    if(forceMode=="SMS"){
      Linking.openURL("sms:"+phone+((Platform.OS === 'ios')?"&":"?")+"body="+message)
    }

    else if(forceMode=="WhatsApp") {
      phone=phone.replace('+', '')
      Linking.openURL('whatsapp://send?text='+message+((Platform.OS === 'ios')?"&":"&")+"phone="+phone )
      
    }
    else this.sendWithSMSQuestion(message,phone,disableClientInfo)





    
  }
  sendWithSMSQuestion(message,phone, sendWithSMSQuestion){
    var newPhone=phone;
    console.log(phone)

    this.alert.onAlert({title:strings.messageSend,subTitle:(sendWithSMSQuestion==true)?undefined:strings.howContactCustomer,buttons:[
    {text: strings.withSMS,onPress: () => {
        Linking.openURL("sms:"+newPhone+((Platform.OS === 'ios')?"&":"?")+"body="+message)
    }},
    {text: strings.withWhatsApp,onPress: () => {
      phone=((phone==undefined)?this.state.clientPhone:phone);
      if(phone!=undefined && phone[0]==0 && info.countryCode=="fr") phone="33"+phone;
      phone=phone.replace('+', '')
      Linking.openURL('whatsapp://send?text='+message+((Platform.OS === 'ios')?"&":"?")+"phone="+phone )


    }},
    {text: strings.cancel,onPress: () => { }}] });

  }


  sendRaceToPartner(){
    var orderDate=new Date(this.state.orderDate)
    orderDate=((orderDate.getDate()<10)?"0":"")+orderDate.getDate()+"/"+(((orderDate.getMonth()+1)<10)?"0":"")+(orderDate.getMonth()+1)+"/"+orderDate.getFullYear()+" - "+((orderDate.getHours()<10)?"0":"")+orderDate.getHours()+":"+((orderDate.getMinutes()<10)?"0":"")+orderDate.getMinutes()

    var raceDate=new Date(this.state.raceDate)
    raceDate=((raceDate.getDate()<10)?"0":"")+raceDate.getDate()+"/"+(((raceDate.getMonth()+1)<10)?"0":"")+(raceDate.getMonth()+1)+"/"+raceDate.getFullYear()+" - "+((raceDate.getHours()<10)?"0":"")+raceDate.getHours()+":"+((raceDate.getMinutes()<10)?"0":"")+raceDate.getMinutes()


    var text="Bonjour, voici la "+((this.state.racePlaceEndNameTest=="" || this.state.racePlaceEndNameTest==undefined)?"mise à disposition":"course")+" en question\nClient : "+this.state.clientName+" "+this.state.clientLastName+"\nTéléphone : "+this.state.clientPhone+"\nEmail: "+this.state.clientEmail+"\nDate de réservation : "+orderDate+"\nDate de départ : "+raceDate+"\nPoint de départ :"+this.state.racePlaceStartName;
    
    if(this.state.stopList!=undefined){
      var stI;
      for(stI=0;stI<this.state.stopList.length;stI++){
        text+="\nArrêt intermédiaire : "+this.state.stopList[stI];
      }
    }

    if(this.state.racePlaceEndNameTest!="" && this.state.racePlaceEndNameTest!=undefined) text+="\nDestination : "+this.state.racePlaceEndName;

    if(this.state.numFlight!=undefined && this.state.numFlight!="") text+="\nNumero de vol : "+this.state.numFlight
    if(this.state.numTrain!=undefined && this.state.numTrain!="") text+="\nNumero de train : "+this.state.numTrain

    text+="\nDurée prévue : "+(((Math.floor(this.state.estimateTimeValue/3600))<10)?"0":"")+Math.floor(this.state.estimateTimeValue/3600)+":"+((Math.floor((this.state.estimateTimeValue%3600)/60)<10)?"0":"")+Math.floor((this.state.estimateTimeValue%3600)/60)+"\nInfos en plus : "+this.state.description
    
    text+="\nPrix : "+this.state.estimatePrice;   

    this.sendWithSMS(text,"",undefined,true)

    
  }

  getDriverPosition(){
    Geolocation.getCurrentPosition(
      position => {
        this.setState({driverPosition:{latitude: position.coords.latitude,longitude: position.coords.longitude, }   })
      },error => {console.log(error); })

  }

 sendImHereMessage(forceMode){
    var basicMessage="Bonjour, je viens d'arriver au "+this.state.racePlaceStartName+" pour notre "+((this.state.racePlaceEndNameTest=="" || this.state.racePlaceEndNameTest==undefined)?"mise à disposition":("réservation vers "+this.state.racePlaceEndName)   ) 

      get(child(ref(getDatabase(firebase)), '/prefill/sms/imhere/fr')).then(valuePrefill => {
       var valPrefill=valuePrefill.val();
       if(valPrefill!=null) {
            basicMessage=valPrefill.name;
            basicMessage = basicMessage.split('%NAME%').join((this.state.clientName!=undefined)?this.state.clientName:"")
            basicMessage = basicMessage.split('%LASTNAME%').join((this.state.clientLastName!=undefined)?this.state.clientLastName:"")
            basicMessage = basicMessage.split('%START%').join((this.state.racePlaceStartName!=undefined)?this.state.racePlaceStartName:"")
            basicMessage = basicMessage.split('%END%').join((this.state.racePlaceEndName!=undefined)?this.state.racePlaceEndName:"mise à disposition")
            basicMessage = basicMessage.split('%DRIVER%').join( (this.state.attributedPartner!=undefined && this.state.attributedPartner!="" && this.state.attributedPartner.text!=undefined)?this.state.attributedPartner.text:"---"); 

        }

        this.sendWithSMS(basicMessage)

    })
    
  }

  sendImCommingMessage(forceMode){
    var basicMessage="Bonjour, je suis en route vers "+this.state.racePlaceStartName+" pour notre "+((this.state.racePlaceEndNameTest=="" || this.state.racePlaceEndNameTest==undefined)?"mise à disposition":("réservation vers "+this.state.racePlaceEndName)   );
      
     get(child(ref(getDatabase(firebase)), '/prefill/sms/imcoming/fr')).then(valuePrefill => {
       var valPrefill=valuePrefill.val();
       if(valPrefill!=null) {
            basicMessage=valPrefill.name;
            basicMessage = basicMessage.split('%NAME%').join((this.state.clientName!=undefined)?this.state.clientName:"")
            basicMessage = basicMessage.split('%LASTNAME%').join((this.state.clientLastName!=undefined)?this.state.clientLastName:"")
            basicMessage = basicMessage.split('%START%').join((this.state.racePlaceStartName!=undefined)?this.state.racePlaceStartName:"")
            basicMessage = basicMessage.split('%END%').join((this.state.racePlaceEndName!=undefined)?this.state.racePlaceEndName:"mise à disposition")
            basicMessage = basicMessage.split('%DRIVER%').join( (this.state.attributedPartner!=undefined && this.state.attributedPartner!="" && this.state.attributedPartner.text!=undefined)?this.state.attributedPartner.text:"---"); 

        }


        if(this.state.driverPosition=={}) {
          basicMessage = basicMessage.split('%DURATION%').join("--"); 
          this.sendWithSMS(basicMessage, undefined, forceMode)
        }
        else{
          


          fetch('https://maps.googleapis.com/maps/api/directions/json?origin=' + this.state.driverPosition.latitude +',' +this.state.driverPosition.longitude +'&destination=' +this.state.racePlaceStartName +'&key='+info.googleMapsKey).then(response => response.json()).then(responseJson => {
           
            if (responseJson.status == 'ZERO_RESULTS' || responseJson.routes[0]==undefined || responseJson.routes[0].legs[0]==undefined || responseJson.routes[0].legs[0].duration==undefined) this.sendWithSMS(basicMessage, undefined, forceMode)
            else {
              var duree=Math.floor(responseJson.routes[0].legs[0].duration.value/60)

              if(duree>0) {
                if(valPrefill!=null) basicMessage = basicMessage.split('%DURATION%').join(duree);
                else basicMessage+=". J'arriverai dans "+duree+" minutes environ";
              }
              else basicMessage = basicMessage.split('%DURATION%').join("--");

              this.sendWithSMS(basicMessage, undefined, forceMode)
              
            }

          }).catch(error=>{
            console.log(error);
            this.sendWithSMS(basicMessage, undefined, forceMode)
          })

        }
    })
    
  }





  calculateMaps(){

    var origin;
    var fetchURLparams={origin:this.state.racePlaceStartName ,type:"directions", key: info.googleMapsKey, minimizeRequest:true,destination:((this.state.racePlaceEndName!=undefined)?this.state.racePlaceEndName:  (  this.state.driverPosition=={} ? "48.8636645,2.3422642" : ( this.state.driverPosition.latitude +',' +this.state.driverPosition.longitude)  ) )}
    
    if(this.state.stopList!=undefined && this.state.stopList.length>0){
        fetchURLparams["waypoints"]=this.state.stopList[0];
        var iWay;
        for(iWay=1; iWay<this.state.stopList.length ; iWay++){
            fetchURLparams["waypoints"]+=("|"+this.state.stopList[iWay])
        }
        
      }
      if(info.avoidHighways==true) fetchURLparams.avoidHighways=true;


     fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/getMapsInfo", {body: JSON.stringify(fetchURLparams),method: "POST"}).then(response => response.json()).then(responseJson => {
        if(typeof(responseJson)!="object") responseJson=JSON.parse(responseJson);
        
        if (responseJson.status != 'ZERO_RESULTS' && responseJson.routes.length>0) {
          var coords=this.decode(responseJson.routes[0].overview_polyline.points);


          var markers=[{latitude:responseJson.routes[0].legs[0]["start_location"].lat,longitude:responseJson.routes[0].legs[0]["start_location"].lng }]

          if(this.state.numTrain!=undefined && this.state.numTrain!="") {
            if(this.state.racePlaceEndName!=undefined && this.state.racePlaceEndName.toUpperCase().search("GARE")!='-1' && this.state.racePlaceStartName.toUpperCase().search("GARE")=='-1') this.setState({numTrainGeolocEnd:true,numTrainGeoloc:{latitude:responseJson.routes[0].legs[0]["end_location"].lat,longitude:responseJson.routes[0].legs[0]["end_location"].lng } })
            else this.setState({numTrainGeolocEnd:false, numTrainGeoloc:{latitude:responseJson.routes[0].legs[0]["start_location"].lat,longitude:responseJson.routes[0].legs[0]["start_location"].lng } })
          }

          if(this.state.racePlaceEndName!=undefined) markers.push({destination:true, latitude:responseJson.routes[0].legs[responseJson.routes[0].legs.length-1]["end_location"].lat,longitude:responseJson.routes[0].legs[responseJson.routes[0].legs.length-1]["end_location"].lng})
          this.setState(() => ({markers:markers,coords:coords}),function(){ this.calculateRegionZoom()})






      }

     })

  }

  sendCancelMail(sendTo){
    const style=styleInfo();
     var date=date=new Date(this.state.raceDate)
     date=((date.getDate()<10)?"0":"")+date.getDate()+"/"+(((date.getMonth()+1)<10)?"0":"")+(date.getMonth()+1)+"/"+date.getFullYear()+" - "+((date.getHours()<10)?"0":"")+date.getHours()+":"+((date.getMinutes()<10)?"0":"")+date.getMinutes()

     var messRequ=(this.state.userRequestAnnulation==true)?"Conformement à votre demande, la course a été annulé":"Nous sommes désolé de vous apprendre que votre réservation a été annulée"
     var list="<html xmlns=\'http://www.w3.org/1999/xhtml\' xmlns:v=\'urn:schemas-microsoft-com:vml\' xmlns:o=\'urn:schemas-microsoft-com:office:office\'><head>  <title></title>  <!--[if !mso]><!-- -->  <meta http-equiv=\'X-UA-Compatible\' content=\'IE=edge\'>  <!--<![endif]--><meta http-equiv=\'Content-Type\' content=\'text/html; charset=UTF-8\'><meta name=\'viewport\' content=\'width=device-width, initial-scale=1.0\'><style type=\'text/css\'>  #outlook a { padding: 0; }  .ReadMsgBody { width: 100%; }  .ExternalClass { width: 100%; }  .ExternalClass * { line-height:100%; }  body { margin: 0; padding: 0; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; }  table, td { border-collapse:collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt; }  img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; }  p { display: block; margin: 13px 0; }</style><!--[if !mso]><!--><style type=\'text/css\'>  @media only screen and (max-width:480px) {    @-ms-viewport { width:320px; }    @viewport { width:320px; }  }</style><!--<![endif]--><!--[if mso]><xml>  <o:OfficeDocumentSettings>    <o:AllowPNG/>    <o:PixelsPerInch>96</o:PixelsPerInch>  </o:OfficeDocumentSettings></xml><![endif]--><!--[if lte mso 11]><style type=\'text/css\'>  .outlook-group-fix {    width:100% !important;  }</style><![endif]--><style type=\'text/css\'>  @media only screen and (min-width:480px) {    .mj-column-per-100 { width:100%!important; }  }</style></head><body style=\'background: #efefefef;\'>    <div class=\'mj-container\' style=\'background-color:#efefefef;\'> <div style=\'margin:0px auto;max-width:600px;background:"+style.color1+";\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;background:"+style.color1+";\' align=\'center\' border=\'0\'><tbody><tr><td style=\'text-align:center;vertical-align:top;direction:ltr;font-size:0px;padding:9px 0px 9px 0px;\'><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><div class=\'mj-column-per-100 outlook-group-fix\' style=\'vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' width=\'100%\' border=\'0\'><tbody><tr><td style=\'word-wrap:break-word;font-size:0px;padding:0px 20px 0px 20px;\' align=\'center\'><div style=\'cursor:auto;color:#000000;font-family:Helvetica, sans-serif;font-size:14px;line-height:22px;text-align:center;\'><h1 style=\'font-family: Helvetica, sans-serif; color: #FFFFFF; font-size: 26px; line-height: 100%;\'>ANNULATION DE RÉSERVATION</h1></div></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]--></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]-->      <!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\' width=\'600\' align=\'center\' style=\'width:600px;\'>        <tr>          <td style=\'line-height:0px;font-size:0px;mso-line-height-rule:exactly;\'>      <![endif]--><div style=\'margin:0px auto;max-width:600px;background:#FFFFFF;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;background:#FFFFFF;\' align=\'center\' border=\'0\'><tbody><tr><td style=\'text-align:center;vertical-align:top;direction:ltr;font-size:0px;padding:9px 0px 9px 0px;\'><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><div class=\'mj-column-per-100 outlook-group-fix\' style=\'vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' width=\'100%\' border=\'0\'><tbody><div style=\'cursor:auto;color:#000000;font-family:Helvetica, sans-serif;font-size:14px;line-height:22px;text-align:center;\'><p>"+messRequ+"</p></div><tr><td style=\'word-wrap:break-word;font-size:0px;padding:10px 25px;padding-top:17px;padding-bottom:17px;padding-right:30px;padding-left:30px;\'><p style=\'font-size:1px;margin:0px auto;border-top:1px dotted #929292;width:100%;\'></p><!--[if mso | IE]><table role=\'presentation\' align=\'center\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:1px;margin:0px auto;border-top:1px dotted #929292;width:100%;\' width=\'600\'><tr><td style=\'height:0;line-height:0;\'>&nbsp;</td></tr></table><![endif]--></td></tr><tr><td style=\'word-wrap:break-word;font-size:0px;padding:0px 25px 0px 25px;\' align=\'left\'><div style=\'cursor:auto;color:#000000;font-family:Helvetica, sans-serif;font-size:14px;line-height:22px;text-align:left;\'><h2 style=\'font-family: Helvetica, sans-serif; line-height: 100%;\'>"+((this.state.racePlaceEndName=="" || this.state.racePlaceEndName==undefined)?"VOTRE MISE A DISPOSITION":"VOTRE TRAJET")+"</h2><p><strong>Départ </strong>: "+this.state.racePlaceStartName+"</p>"+((this.state.racePlaceEndName!="" && this.state.racePlaceEndName!=undefined)?"<p><strong>Arrivée </strong>: "+this.state.racePlaceEndName+"</p>":"")+"<p><strong>Jour &amp; heure </strong>: "+date+"</p><p><strong>Durée </strong>: "+(((Math.floor(this.state.estimateTimeValue/3600))<10)?"0":"")+Math.floor(this.state.estimateTimeValue/3600)+":"+((Math.floor((this.state.estimateTimeValue%3600)/60)<10)?"0":"")+Math.floor((this.state.estimateTimeValue%3600)/60)+"</p>"+((this.state.racePlaceEndName!="" && this.state.racePlaceEndName!=undefined)?"<p><strong>Km </strong>: "+this.state.estimateKm+"</p>":"")+"<p><strong>Véhicule </strong>: "+this.state.carName+"</p><p><strong>Prix </strong>: "+this.state.estimatePrice+"</p><p><strong>Commentaire </strong>: "+this.state.description+"</p></div></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]--></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]-->      <!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\' width=\'600\' align=\'center\' style=\'width:600px;\'>        <tr>          <td style=\'line-height:0px;font-size:0px;mso-line-height-rule:exactly;\'>      <![endif]--><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;\' border=\'0\'><tbody><tr><td><div style=\'margin:0px auto;max-width:600px;background:#FFFFFF;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;\' align=\'center\' border=\'0\'><tbody><tr><td style=\'text-align:center;vertical-align:top;direction:ltr;font-size:0px;padding:0px 0px 0px 0px;\'><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><div class=\'mj-column-per-100 outlook-group-fix\' style=\'vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' width=\'100%\' border=\'0\'><tbody><tr><td style=\'word-wrap:break-word;font-size:0px;padding:0px 25px 0px 25px;\' align=\'center\'><div style=\'cursor:auto;color:#000000;font-family:Helvetica, sans-serif;font-size:14px;line-height:22px;text-align:center;\'><p>Pour toute annulation n\'oubliez pas de nous tenir inform&#xE9;s via l\'onglet contact de l\'application ou par email <a href=\'mailto:"+this.state.companyEmail+"?subject=Annulation&amp;body=Annulation\' style=\'color: "+style.color1+"\'>"+this.state.companyEmail+"</a></p></div></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]--></td></tr></tbody></table></div></table><!--[if mso | IE]>      </td></tr></table>      <![endif]--><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\' width=\'600\' align=\'center\' style=\'width:600px;\'>        <tr>          <td style=\'line-height:0px;font-size:0px;mso-line-height-rule:exactly;\'>      <![endif]--><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;\' border=\'0\'><tbody><tr><td><div style=\'margin:0px auto;max-width:600px;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;\' align=\'center\' border=\'0\'><tbody><tr><td style=\'text-align:center;vertical-align:top;direction:ltr;font-size:0px;padding:0px 0px 0px 0px;\'><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><div class=\'mj-column-per-100 outlook-group-fix\' style=\'vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' width=\'100%\' border=\'0\'><tbody><tr><td style=\'word-wrap:break-word;font-size:0px;\'><div style=\'font-size:1px;line-height:50px;white-space:nowrap;\'>&nbsp;</div></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]--></td></tr></tbody></table></div></td></tr></tbody></table><!--[if mso | IE]>      </td></tr></table>      <![endif]-->      <!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\' width=\'600\' align=\'center\' style=\'width:600px;\'>        <tr>          <td style=\'line-height:0px;font-size:0px;mso-line-height-rule:exactly;\'>      <![endif]--><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'background:#333333;font-size:0px;width:100%;\' border=\'0\'><tbody><tr><td><div style=\'margin:0px auto;max-width:600px;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;\' align=\'center\' border=\'0\'><tbody><tr><td style=\'text-align:center;vertical-align:top;direction:ltr;font-size:0px;padding:9px 0px 9px 0px;\'><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><div class=\'mj-column-per-100 outlook-group-fix\' style=\'vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' width=\'100%\' border=\'0\'><tbody><tr><td style=\'word-wrap:break-word;font-size:0px;\'><div style=\'font-size:1px;line-height:50px;white-space:nowrap;\'>&nbsp;</div></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]--></td></tr></tbody></table></div></td></tr></tbody></table><!--[if mso | IE]>      </td></tr></table>      <![endif]-->      <!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\' width=\'600\' align=\'center\' style=\'width:600px;\'>        <tr>          <td style=\'line-height:0px;font-size:0px;mso-line-height-rule:exactly;\'>      <![endif]--><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'background:#333333;font-size:0px;width:100%;\' border=\'0\'><tbody><tr><td><div style=\'margin:0px auto;max-width:600px;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' style=\'font-size:0px;width:100%;\' align=\'center\' border=\'0\'><tbody><tr><td style=\'text-align:center;vertical-align:top;direction:ltr;font-size:0px;padding:9px 0px 9px 0px;\'><!--[if mso | IE]>      <table role=\'presentation\' border=\'0\' cellpadding=\'0\' cellspacing=\'0\'>        <tr>          <td style=\'vertical-align:top;width:600px;\'>      <![endif]--><div class=\'mj-column-per-100 outlook-group-fix\' style=\'vertical-align:top;display:inline-block;direction:ltr;font-size:13px;text-align:left;width:100%;\'><table role=\'presentation\' cellpadding=\'0\' cellspacing=\'0\' width=\'100%\' border=\'0\'><tbody><tr><td style=\'word-wrap:break-word;font-size:0px;padding:0px 20px 0px 20px;\' align=\'center\'><div style=\'cursor:auto;color:#000000;font-family:Helvetica, sans-serif;font-size:11px;line-height:22px;text-align:center;\'><p><span style=\'color:#ffffff;\'>"+this.state.companyBrand+" | "+this.state.companyAdress+" | "+this.state.companyCity+" | "+this.state.companyPhone+" | "+this.state.companyEmail+"</span></p></div></td></tr></tbody></table></div><!--[if mso | IE]>      </td></tr></table>      <![endif]--></td></tr></tbody></table></div></td></tr></tbody></table><!--[if mso | IE]>      </td></tr></table>      <![endif]--></div></body></html>"                            

     if(sendTo==undefined || sendTo=="providerCustomer"){
      getAuth(firebase).currentUser.getIdToken().then(token => {

            var bodyInfo={
                toEmail:this.state.clientEmail,
                toName:this.state.clientName+" "+this.state.clientLastName, 
                subject: "Annulation de réservation", 
                HTMLPart:list, 
                replyToEmail:info.companyEmail,
                replyToName:info.companyBrand,
                token:token,
                fromEmail:info.mavEmail,
                fromName:info.companyBrand,
                userID:getAuth(firebase).currentUser.uid,

            }

            console.log(bodyInfo)
            this.firebaseSendByMail(bodyInfo)

            


        })
     }



      if(sendTo=="provider" || sendTo=="providerCustomer"){
          getAuth(firebase).currentUser.getIdToken().then(token => {

            var bodyInfo={
                toEmail:this.state.providerEmail,
                toName:this.state.providerName+" "+this.state.providerLastName, 
                subject: "Annulation de réservation", 
                HTMLPart:list, 
                replyToEmail:info.companyEmail,
                replyToName:info.companyBrand,
                token:token,
                fromEmail:info.mavEmail,
                fromName:info.companyBrand,
                userID:getAuth(firebase).currentUser.uid,

            }
            this.firebaseSendByMail(bodyInfo)

            
        })

      }

  }



  cancelNextActions(sendToFRB){
    var params=(this.props.route!=undefined)?this.props.route.params:this.props;  
    const fireInfo={} 
    for (const [key, value] of Object.entries(sendToFRB)) {
      fireInfo['race/' +this.state.id+"/"+key]=value;
    }
    update(ref(getDatabase(firebase)), fireInfo)

    this.setState({status:"cancel"})

    if(params.nextWaitingRace!=undefined){
      params.nextWaitingRace("cancel")
    } else if(params.removeDate!=undefined){
      params.removeDate(this.state.id)
    }
    if(this.props.route!=undefined) this.props.navigation.goBack();
    else this.props.goBack()
  
  }

  validateNextActions(){
    var params=(this.props.route!=undefined)?this.props.route.params:this.props;     
    if(params.nextWaitingRace!=undefined){
      params.nextWaitingRace("validate")
      if(this.props.route!=undefined) this.props.navigation.goBack();
    else this.props.goBack()
    }
  }

  exportToAgenda(){
    var params=(this.props.route!=undefined)?this.props.route.params:this.props;     
    this.setState({waitingLink:true})

    var summary=(this.state.racePlaceEndNameTest=="" || this.state.racePlaceEndNameTest==undefined)?("Mise à disposition"):("Course de "+this.state.racePlaceStartName+" vers "+this.state.racePlaceEndName)
    var description="Client : "+this.state.clientName+" "+this.state.clientLastName

    if(this.state.clientPhone!=undefined &&(params.driver==true || (params.partner==true && (this.state.viewPhone=="always" || (this.state.viewPhone=="onlyManualClient" && this.state.providerID!=undefined) ) )))description+=" ( "+this.state.clientPhone+" )";

    description+=" - ";

    if( this.state.hidePriceRaceForDriver==false || ((this.state.charge==undefined ||  this.state.charge.capture=="stripeError") &&  this.state.alreadyPaid!=true && this.state.deferredPayment!=true && this.state.karhooProvider!=true && (this.state.paymentDriverMode!="onlyDriver" && this.state.paymentDriverMode!="driverAndClient") )  ) description+= "Prix client : "+this.state.estimatePrice+" - ";
    if( this.state.priceNetForDriver==true) description+="Prix chauffeur : "+this.state.driverPrice+" - ";

    description+=this.state.description;

    var dateAct=new Date();
    var DTSTAMP=dateAct.toISOString();
    DTSTAMP=DTSTAMP.split('-').join('')
    DTSTAMP=DTSTAMP.split(':').join('')
    DTSTAMP=DTSTAMP.slice(0, 15)+"Z"

    var raceDate=new Date(this.state.raceDate);
    var DTSTART=raceDate.toISOString();
    DTSTART=DTSTART.split('-').join('')
    DTSTART=DTSTART.split(':').join('')
    DTSTART=DTSTART.slice(0, 15)+"Z"

    var duration="PT"+(Math.floor(this.state.estimateTimeValue/3600)<10?"0":"")+Math.floor(this.state.estimateTimeValue/3600)+"H"+((Math.floor((this.state.estimateTimeValue-3600*Math.floor(this.state.estimateTimeValue/3600))/60)<10)?"0":"")+Math.floor((this.state.estimateTimeValue-3600*Math.floor(this.state.estimateTimeValue/3600))/60)+"M"
    var generateICS="BEGIN:VCALENDAR\n"
        generateICS+="VERSION:2.0\n"
        generateICS+="CALSCALE:GREGORIAN\n"
        generateICS+="PRODID:monapplivtc/ics\n"
        generateICS+="METHOD:PUBLISH\n"
        generateICS+="X-PUBLISHED-TTL:PT1H\n"
        generateICS+="BEGIN:VEVENT\n"
        generateICS+="UID:"+this.state.id+"\n"
        generateICS+="SUMMARY:"+summary+"\n"
        generateICS+="DTSTAMP:"+DTSTAMP+"\n"
        generateICS+="DTSTART:"+DTSTART+"\n"
        generateICS+="DESCRIPTION:"+description+"\n"
        generateICS+="X-MICROSOFT-CDO-BUSYSTATUS:BUSY\n"
        generateICS+="STATUS:CONFIRMED\n"
        generateICS+="DURATION:"+duration+"\n"
        generateICS+="END:VEVENT\n"
        generateICS+="END:VCALENDAR\n"


        getAuth(firebase).currentUser.getIdToken().then(token => {
        var body={
              userID:getAuth(firebase).currentUser.uid,
              bundleIdentifer:info.bundleIdentifer,
              bundleAdress:info.firebaseProjectID,
              token:token,
              icsContent:generateICS, 
              date:Date.parse(new Date()),
          }


          fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/generateICS", {body:JSON.stringify(body),method: "POST"}).then((response) => response.json())
                  .then((responseJson) => {
                    console.log("tout est ok")
                    if(responseJson.link==undefined) {this.setState({waitingLink:false}); this.alert.onAlert({title:strings.errorDefault}) }
                    else {
                        timer.setTimeout("timerLk", () => {
                          this.setState({waitingLink:false});
                          console.log(responseJson.link)
                          Linking.openURL(responseJson.link)

                        }, 1000);
                    }

                  }).catch((err) => { console.log("error exportToAgenda"); console.log(err); timer.setTimeout("exportToAgenda", () => { this.exportToAgenda();  }, 2000);   })




        })

  }

  calculateRegionZoom(forcePoints){

    var points=(forcePoints!=undefined)?forcePoints:this.state.markers;
    if(points.length>0){
      var minX = points[0].latitude;
      var maxX = points[0].latitude;
      var minY = points[0].longitude;
      var maxY = points[0].longitude;

      var i;

      for(i=1;i<points.length+1;i++){
        minX = Math.min(minX, points[i-1].latitude);
        maxX = Math.max(maxX, points[i-1].latitude);
        minY = Math.min(minY, points[i-1].longitude);
        maxY = Math.max(maxY, points[i-1].longitude);
      }
      

      var midX = ((minX + maxX) / 2)
      var midY = ((minY + maxY) / 2)
      
      var deltaX, deltaY;

      if(forcePoints!=undefined){
        deltaX= Math.abs(minX-maxX)*2
        deltaY = Math.abs(minY-maxY)*2
      }
      else {
        deltaX= Math.abs(minX-maxX)*2.1+0.05;
        deltaY = Math.abs(minY-maxY)*2.1+0.05;
      }


      var r={latitude: midX, longitude: midY,latitudeDelta: deltaX, longitudeDelta: deltaY};
      if(forcePoints!=undefined) return {latitude: midX, longitude: midY,latitudeDelta: deltaX, longitudeDelta: deltaY}; 

      else this.setState({regionZoom:{latitude: midX, longitude: midY,latitudeDelta: deltaX, longitudeDelta: deltaY}})
    }
  }

  sendRemoveRace(forceRemove){
    var sendToFRB={
      status:((this.state.saveRemovedRace==true && forceRemove!=true) || (this.state.status=="finish" && forceRemove!=true) || this.state.karhooProvider==true)?"cancel":"remove"
    }


    if(this.state.saveRemovedRace==true){
        sendToFRB.cancelRaceDate=Date.parse(new Date());
        sendToFRB.cancelRaceDriver=this.state.actualUserName+" "+this.state.actualUserLastName; 


    }

    
    if(this.state.charge!=undefined){

        if(this.state.providerID!=undefined && this.state.providerID!=""){
            this.alert.onAlert({title:strings.userAlreadyPaidRefundQuetionPart1,subTitle:strings.userAlreadyPaidRefundQuetionWithProvider,buttons:[
            {text: strings.ok,onPress: () => {this.sendCancelMessageDriver(sendToFRB);}},
            ],});
        }
        else {
          this.alert.onAlert({title:strings.userAlreadyPaidRefundQuetionPart1,subTitle:strings.userAlreadyPaidRefundQuetionPart2,buttons:[
            {text: strings.yes,onPress: () => {this.sendRefundRequest();this.sendCancelMessageDriver(sendToFRB);}},
            {text: strings.no,onPress: () => {this.sendCancelMessageDriver(sendToFRB);}},
            ],});
        }

        

    }
    else {
      this.sendCancelMessageDriver(sendToFRB);
    }

  }

  sendRefundRequest(){
    if(this.state.chargeAfterRace!=undefined) Alert.onAlert({title:"Impossible de rembourser. Utilisez Stripe directement"})
    else {

        getAuth(firebase).currentUser.getIdToken().then(token => {
              var body={
                  userID:getAuth(firebase).currentUser.uid,
                  bundleIdentifer:info.bundleIdentifer,
                  chargeID:this.state.charge.chargeID,
                  token:token,
                  bundleAdress:info.firebaseProjectID,
              }

              fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/refundRace", {
                      body:JSON.stringify(body),
                      headers: {"Content-Type": "application/json"},method: "POST"}).then(response => response.json()).then(responseJson => {}).catch((err) => { console.log("error sendRefundRequest"); console.log(err); timer.setTimeout("sendRefundRequest", () => { this.sendRefundRequest();  }, 2000);   })

          }) 
      }


  }

  sendCancelMessageDriver(sendToFRB){

    if(this.state.attributedPartner!=undefined && this.state.attributedPartner.id!=getAuth(firebase).currentUser.uid){
                var date=date=new Date(this.state.raceDate)
                date=((date.getDate()<10)?"0":"")+date.getDate()+"/"+(((date.getMonth()+1)<10)?"0":"")+(date.getMonth()+1)+" à "+((date.getHours()<10)?"0":"")+date.getHours()+":"+((date.getMinutes()<10)?"0":"")+date.getMinutes()
    
                this.alert.onAlert({largeButton:true, title:strings.cancelRaceDriver, buttons:[{text: strings.yes,onPress: () => {

                  getAuth(firebase).currentUser.getIdToken().then(token => {
                      var body={securisedTask:true,userID:getAuth(firebase).currentUser.uid,bundleIdentifer:info.bundleIdentifer,message:"La course du "+date+" a été annulée",clientID:this.state.attributedPartner.id,token:token,title:"Course annulée",bundleAdress:info.firebaseProjectID,}
                      this.firebaseSendByMessage(body)
                    })
                  this.sendCancelMessage(sendToFRB); 


                }}, {text: strings.no,onPress: () => {this.sendCancelMessage(sendToFRB); }} ]});


                
              }
    else this.sendCancelMessage(sendToFRB)

  }

  sendCancelMessage(sendToFRB){


    

    var buttons=[]; 
    var date=date=new Date(this.state.raceDate)
    date=((date.getDate()<10)?"0":"")+date.getDate()+"/"+(((date.getMonth()+1)<10)?"0":"")+(date.getMonth()+1)+"/"+date.getFullYear()+" à "+((date.getHours()<10)?"0":"")+date.getHours()+":"+((date.getMinutes()<10)?"0":"")+date.getMinutes()
    var textAnnulation="Bonjour, nous sommes au regret de vous informer que nous ne pourrons pas effectuer la course du "+date;
    if(this.state.userRequestAnnulation===true) textAnnulation="Bonjour, nous avons bien pris en compte votre demande d'annulation pour la course du "+date; 




    get(child(ref(getDatabase(firebase)), '/prefill/sms/'+((this.state.userRequestAnnulation===true)?"userRequestAnnulation":"cancelRace")+"/fr")).then(valuePrefill => {
       var valPrefill=valuePrefill.val();
       if(valPrefill!=null) {
            textAnnulation=valPrefill.name;
            textAnnulation = textAnnulation.split('%NAME%').join((this.state.clientName!=undefined)?this.state.clientName:"")
            textAnnulation = textAnnulation.split('%LASTNAME%').join((this.state.clientLastName!=undefined)?this.state.clientLastName:"")
            textAnnulation = textAnnulation.split('%DATE%').join(date)
            textAnnulation = textAnnulation.split('%START%').join((this.state.racePlaceStartName!=undefined)?this.state.racePlaceStartName:"")
            textAnnulation = textAnnulation.split('%END%').join((this.state.racePlaceEndName!=undefined)?this.state.racePlaceEndName:"mise à disposition")
            textAnnulation = textAnnulation.split('%DRIVER%').join( (this.state.attributedPartner!=undefined && this.state.attributedPartner!="" && this.state.attributedPartner.text!=undefined)?this.state.attributedPartner.text:"---"); 

        }

        if(this.state.clientPhone!=undefined && this.state.clientPhone!="" && Platform.OS!="web") {
          buttons.push({text: strings.withSMS,onPress: () => {
              this.cancelNextActions(sendToFRB);
              this.sendWithSMS(textAnnulation,undefined,"SMS")

          }})


          buttons.push({text: strings.withWhatsApp,onPress: () => {
                this.cancelNextActions(sendToFRB);
                this.sendWithSMS(textAnnulation,undefined,"WhatsApp")
          }});

        }
        if(this.state.clientEmail!=undefined && this.state.clientEmail!="" ){
          buttons.push({text: strings.withMail,onPress: () => {
          this.sendCancelMail();
          this.cancelNextActions(sendToFRB);
          }})
        }

        if(this.state.providerEmail!=undefined && this.state.providerEmail!="" ){
          buttons.push({firstText:strings.providerAffair,text: strings.withMail,onPress: () => {
          this.sendCancelMail("provider");
          this.cancelNextActions(sendToFRB);
          }})


          if(this.state.clientEmail!=undefined && this.state.clientEmail!="" ){
          buttons.push({firstText:strings.customer+" + "+strings.providerAffair, text: strings.withMail,onPress: () => {
          this.sendCancelMail("providerCustomer");
          this.cancelNextActions(sendToFRB);
          }})


          }
        }


        buttons.push({text: strings.notPrevent,onPress: () => {this.cancelNextActions(sendToFRB);}})


        if(this.state.karhooProvider!=true) this.alert.onAlert({largeButton:true, title:strings.raceHasBeenCanceled,subTitle:(this.state.providerID!=undefined)?strings.howWhoContact:strings.howContactCustomer,buttons:buttons});
        else this.cancelNextActions(sendToFRB);

    })

  }
  duplicateRace = (dateTxt, date) => {
  
      var arrowQuestions=[{text:strings.validationWaiting ,value:false }];
      if(this.state.racePlaceEndNameTest!=undefined)  arrowQuestions.push({text:strings.returnMode ,value:false }) 


      if(dateTxt==undefined) this.alert.onAlert({title:strings.duplicateRace, arrowQuestions:arrowQuestions, subTitle:strings.duplicateRaceMoreInfo+( (this.state.charge!=undefined)?(". "+strings.duplicateRaceMoreInfoCharge):"" ), buttons:[{text: strings.next,onPress: (value) => { 

                this.setState({changeDateDuplicate:true,duplicateWithWaiting:(value[0]!=undefined && value[0].value==true)?true:false, duplicateRaceInversion:(value[1]!=undefined && value[1].value==true)?true:false }); this.selectDate.onPicker(new Date(this.state.raceDate))
              }},  {text: strings.cancel, style:"cancel",onPress: () => {}} 
              ],});

      else {
          var params=(this.props.route!=undefined)?this.props.route.params:this.props;   
          var valDup=JSON.parse(JSON.stringify(params.data))
        
          if(valDup==null || valDup.racePlaceStartName==undefined) this.alert.onAlert({title:strings.errorDefault,})
          else {
              

              valDup.status=(this.state.duplicateWithWaiting==true)?"waiting":"validate"; 
              if(this.state.duplicateWithWaiting==true) delete valDup.attributedPartner; 
              delete valDup.charge;
              delete valDup.raceInProgress;
              delete valDup.immediateMode;
              delete valDup.withPaymentLink
              delete valDup.stripePublicKey
              delete valDup.linkPrice
              delete valDup.chargeAfterRace
              delete valDup.numFlight
              delete valDup.numTrain
              delete valDup.billNumber; 
              delete valDup.billNumberDriver; 




              valDup.raceDate=date;
              valDup.raceDateFixed=dateTxt;
              var save,i; 
              if(valDup.desiredDriver!=undefined) valDup.desiredDriver.duplicate=true;
              /*invertion de la course*/
              if(this.state.duplicateRaceInversion==true){
                save=valDup.racePlaceStartName
                valDup.racePlaceStartName=valDup.racePlaceEndName
                valDup.racePlaceEndName=save;
              }

              var stopList=[];
              if(valDup.stopList!=undefined && valDup.stopList!="" && valDup.stopList.length>1){
                for(i=valDup.stopList.length; i>0; i--) stopList.push(valDup.stopList[i-1]);
              }

              valDup.stopList=stopList;

              if(valDup.passagersList!=undefined && valDup.passagersList!="" && valDup.passagersList.length>1){
                  for(i=0; i<valDup.passagersList.length;i++){
                      if(valDup.passagersList[i].start!=undefined){
                          if(valDup.passagersList[i].end!=undefined){
                            save=valDup.passagersList[i].start;
                            valDup.passagersList[i].start=valDup.passagersList[i].end
                            valDup.passagersList[i].end=save;
                          }
                          else {
                              valDup.passagersList[i].end=valDup.passagersList[i].start; 
                              delete valDup.passagersList[i].start;
                          }
                      }
                      else if(valDup.passagersList[i].end!=undefined){
                        valDup.passagersList[i].start=valDup.passagersList[i].end; 
                        delete valDup.passagersList[i].end;

                      }
                  } 

              }

              /*sauvegarde des informations*/
              var uuid=generateUUID();
              const fireInfo={} 
              fireInfo['race/' +uuid]=valDup
              update(ref(getDatabase(firebase)), fireInfo)

              if(valDup.attributedPartner!=undefined && valDup.attributedPartner.id!=getAuth(firebase).currentUser.uid){
                console.log("je préviens le chauffeur ")

                getAuth(firebase).currentUser.getIdToken().then(token => {
                      var body={securisedTask:true,userID:getAuth(firebase).currentUser.uid,bundleIdentifer:info.bundleIdentifer,message:"Une course vous a été attribué. Ouvrez l'appli pour en savoir plus",clientID:valDup.attributedPartner.id,token:token,title:"Nouvelle course pour le "+valDup.raceDateFixed,bundleAdress:info.firebaseProjectID,}
                      this.firebaseSendByMessage(body)
                    })
              }

              this.alert.onAlert({title:strings.raceHasBeenDuplicate,})
          }
          
      }

  }

  changeDuration = data => {

   var estTV= (Math.floor(this.state.estimateTimeValue/3600)<10?"0":"")+Math.floor(this.state.estimateTimeValue/3600)+":"+((Math.floor((this.state.estimateTimeValue-3600*Math.floor(this.state.estimateTimeValue/3600))/60)<10)?"0":"")+Math.floor((this.state.estimateTimeValue-3600*Math.floor(this.state.estimateTimeValue/3600))/60)
   console.log("this.state.estimateTimeValue ="+this.state.estimateTimeValue)

    this.alert.onAlert({title:strings.duration,textInput:{placeholder:"00:00",text:estTV,sizeMultiplicator:2,typeHour:true,keyboardType:"numeric"},buttons:[
                    {text: strings.validate,onPress: (value) => {
                       if(value.length==5 && parseInt(value[0]+value[1])<24 && parseInt(value[3]+value[4])<60 ){
                        var valueFinal=(parseInt(value[0]+value[1])*60+parseInt(value[3]+value[4]) )*60;
                        console.log("valueFinal "+valueFinal)
                        this.setState({estimateTimeValue:valueFinal, change:true})
                        this.onChangeQuestionPrice()
                       }
                       else {
                         this.alert.onAlert({title:strings.errorHour,})
                       }
                    }},
                    {text: strings.cancel, style:"cancel",onPress: () => {}}
                    ],})
  }

  helpGoBack= data => {
    
    this.setState({seeHelpRace:false})

  }

  modifyRaceDecision= data => {
    var infoModif=JSON.parse(JSON.stringify(this.state.modify));
    var i; 

    /*je supprime le /race/id/modify */
    const fireInfo={} 
    fireInfo['/race/'+this.state.id+"/modify"]=null
    
    this.setState({modify:undefined})

    /* je previens le client avec accept ou decline */
    if(this.state.providerID!=undefined && this.state.providerID!="") fireInfo['usersRace/' +this.state.providerID+"/"+ this.state.id+"/reqMod"]=(data==true)?"accept":"decline"
    else if(this.state.clientID!=undefined && this.state.clientID!="") fireInfo['usersRace/' +this.state.clientID+"/"+ this.state.id+"/reqMod"]=(data==true)?"accept":"decline"

      var st={}
    /* si data == true je modifie les informations*/
    if(data==true){
      
      if(this.state.modify.racePlaceStartName!=undefined) st.racePlaceStartName=this.state.modify.racePlaceStartName;
      if(this.state.modify.racePlaceEndName!=undefined) st.racePlaceEndName=this.state.modify.racePlaceEndName;
      if(this.state.modify.clientName!=undefined) st.clientName=this.state.modify.clientName;
      if(this.state.modify.clientLastName!=undefined) st.clientLastName=this.state.modify.clientLastName;

      if(this.state.modify.raceDate!=undefined){
        st.raceDate=this.state.modify.raceDate;
        var date=new Date(this.state.modify.raceDate)
        date=((date.getDate()<10)?"0":"")+date.getDate()+"/"+(((date.getMonth()+1)<10)?"0":"")+(date.getMonth()+1)+"/"+date.getFullYear()+" - "+((date.getHours()<10)?"0":"")+date.getHours()+":"+((date.getMinutes()<10)?"0":"")+date.getMinutes()
        st.date=date; 
      }

     if(this.state.modify.description!=undefined) st.description=this.state.description+" - "+this.state.modify.description;
     if(this.state.modify.stopList!=undefined){
        var stopList=[]; 
        for(i=0;i<this.state.modify.stopList.length;i++){
          if(this.state.modify.stopList[i]==undefined) stopList.push(this.state.stopList[i]);
          else if(this.state.modify.stopList[i]!="removed") stopList.push(this.state.modify.stopList[i]);
        }
        if(stopList.length==0) st.stopList=null
        else st.stopList=stopList;

     }

     if(this.state.modify.passagersList!=undefined){
        var passagersList=[]; 
        for(i=0;i<((this.state.modify.passagersList.length > this.state.passagersList.length)?this.state.modify.passagersList.length:this.state.passagersList.length) ;i++){
          console.log("pour i="+i)
          console.log(this.state.modify.passagersList[i])

          if(this.state.modify.passagersList[i]==undefined) passagersList.push(this.state.passagersList[i]);
          else if(this.state.modify.passagersList[i]!="removed") {
              var infoPS={name:this.state.passagersList[i].name, lastName:this.state.passagersList[i].lastName}
              if(this.state.modify.passagersList[i].name!=undefined) infoPS.name=this.state.modify.passagersList[i].name
              if(this.state.modify.passagersList[i].lastName!=undefined) infoPS.lastName=this.state.modify.passagersList[i].lastName
              passagersList.push(infoPS);
          }
        }
        st.passagersList=passagersList;


     }
     
    }

     var sendInfoClient={status:(data==true)?"accept":"decline"}
     if(this.state.providerID!=undefined) sendInfoClient.providerID=this.state.providerID;
     else sendInfoClient.clientID=this.state.clientID;
     st.change=true;

     console.log('/modifyRace/'+this.state.id+"/sendInfoClient")
     fireInfo['/modifyRace/'+this.state.id+"/sendInfoClient"]=sendInfoClient
     update(ref(getDatabase(firebase)), fireInfo)
        
     this.setState(st);
     if(data==true){this.onChangeQuestionPrice()}

  }


  modifyRaceFromHelp= (type,data) => {
    console.log("modifyRaceFromHelp")
    console.log(type)
      
      if(type=="duration") this.setState({estimateTimeValue:data, change:true})
      else if(type=="provisionMode") this.setState({racePlaceEndName:undefined,stopList:undefined,racePlaceEndNameTest:undefined, estimateKm:undefined, change:true, changeFromHelp:true})
      else if(type=="endAdress") this.setState({racePlaceEndName:data,racePlaceEndNameTest:data, estimateKm:"", change:true, changeFromHelp:true})
        else if(type=="km") this.setState({estimateKm:data, change:true, changeFromHelp:true})
      else if(type=="status") {
        if(this.state.charge!=undefined){
          var ch=this.state.charge;
          ch.alreadyCharge=true; 
          this.setState({status:data, charge:ch, changeDeferredID:true, change:true, changeFromHelp:true})
        }
        else this.setState({status:data, change:true, changeFromHelp:true})
        if(data=="waiting"){

          this.alert.onAlert({title:strings.fromWaiting,buttons:[{text: strings.ok,onPress: () => { 
                if(Platform.OS!="web") this.props.navigation.dispatch(CommonActions.reset({index: 0,routes: [{ name: 'Main' },],}) );
                else this.props.goBack() }},   
              ],});
        }
      }

  }

  generatePDFInfo(){

    var orderDate=new Date(this.state.orderDate)
    orderDate=((orderDate.getDate()<10)?"0":"")+orderDate.getDate()+"/"+(((orderDate.getMonth()+1)<10)?"0":"")+(orderDate.getMonth()+1)+"/"+orderDate.getFullYear()+" - "+((orderDate.getHours()<10)?"0":"")+orderDate.getHours()+":"+((orderDate.getMinutes()<10)?"0":"")+orderDate.getMinutes()

    var pdfInfo={
      placeStart:this.state.racePlaceStartName,
      date:this.state.date,
      orderDate:orderDate,


      estimateTimeValue:(Math.floor(this.state.estimateTimeValue/3600)<10?"0":"")+Math.floor(this.state.estimateTimeValue/3600)+":"+((Math.floor((this.state.estimateTimeValue-3600*Math.floor(this.state.estimateTimeValue/3600))/60)<10)?"0":"")+Math.floor((this.state.estimateTimeValue-3600*Math.floor(this.state.estimateTimeValue/3600))/60),
      roundTrip:(this.state.goReturnTaxi==true)?true:false,
      description:this.state.description,
      subTitle:"Voici un récapitulatif des informations "
    }

   


    if(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" && info.trackLink!=undefined && (this.state.providerID!=undefined || this.state.customerPro==true) && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance") ) ))  pdfInfo.tracklink=(info.trackLink+"/?trackLink="+this.state.id)

    if(this.state.racePlaceEndNameTest!=undefined && this.state.racePlaceEndNameTest!="") {pdfInfo.placeEnd=this.state.racePlaceEndName; pdfInfo.title="VOTRE COURSE"; pdfInfo.subTitle+="pour votre course"}
    else {pdfInfo.title="VOTRE MISE À DISPOSITION"; pdfInfo.subTitle+="pour votre mise à disposition"}

    if(pdfInfo.tracklink!=undefined) pdfInfo.subTitle+=". En flashant le QR code ci-dessous, vous pourrez suivre cette course dans votre navigateur";

    if(this.state.estimatePrice!=undefined && this.state.estimatePrice!="") pdfInfo.estimatePrice=this.state.estimatePrice;
    if(this.state.params.driver!=true && this.state.driverPrice!=undefined){pdfInfo.estimatePrice=this.state.driverPrice;}
    if(this.state.numFlight!=undefined && this.state.numFlight!="") pdfInfo.numFlight=this.state.numFlight;
    if(this.state.numTrain!=undefined && this.state.numTrain!="") pdfInfo.numTrain=this.state.numTrain;
    if(this.state.estimateKm!=undefined && this.state.estimateKm!="") pdfInfo.estimateKm=this.state.estimateKm;
    if(this.state.stopList!=undefined && this.state.stopList!="") pdfInfo.stopList=this.state.stopList;
    

    if(this.state.providerEnterprise!=undefined && this.state.providerEnterprise!="" && this.state.driver==true) pdfInfo.providerEnterprise=this.state.providerEnterprise;
    if(this.state.providerName!=undefined && this.state.providerName!="" && this.state.driver==true) pdfInfo.providerName=this.state.providerName;
    if(this.state.providerLastName!=undefined && this.state.providerLastName!="" && this.state.driver==true) pdfInfo.providerLastName=this.state.providerLastName;

    var phone=(!(this.state.clientPhone!=undefined && this.state.clientPhone!="" && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.viewPhone=="always" || (this.state.viewPhone=="onlyManualClient" && (this.state.customerPro==true || this.state.providerID!=undefined)) )))))?info.companyPhone:this.state.clientPhone;
    var passagers=[this.state.clientName+" "+this.state.clientLastName+" ("+phone+")"];
    if(this.state.passagersList!=undefined && this.state.passagersList!="" && this.state.passagersList.length>0){
      var i;
      for(i=0;i<this.state.passagersList.length;i++){
        passagers.push(this.state.passagersList[i].name+" "+this.state.passagersList.lastName)
      }
    }
    pdfInfo.passagers=passagers;

    if(this.state.attributedPartner!=undefined && this.state.attributedPartner!=""){
      pdfInfo.driver=this.state.attributedPartner.text;
    }
    if(this.state.carName!=undefined && this.state.carName!="") pdfInfo.carName=this.state.carName

      return pdfInfo

  }

  generatePDF= data => {
    
    var pdfInfo=this.generatePDFInfo()
    this.props.navigation.navigate("MavPDF",{mode:"generate", info:pdfInfo, title:strings.race});
    

  }

  changePriceClient = data => {

    console.log("this.state.estimatePrice = "+this.state.estimatePrice)

     this.alert.onAlert({title:strings.priceSettings,textInput:{placeholder:((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+"40"+((this.state.money.position=="right")?(this.state.money.symbole):""),text:this.state.estimatePrice,sizeMultiplicator:2,detectSequencePosition:this.state.money.position,detectSequence:this.state.money.symbole,keyboardType:"numeric"},buttons:[
      {text: strings.validate,onPress: (value) => {
         var estg=value.toString().replace(this.state.money.symbole,'')
        estg=parseFloat(estg);

        if(!isNaN(estg) ){
          this.setState({estimatePrice:value, change:true})
          

          this.alert.onAlert({title:strings.changePriceDriver, subTitle:strings.forceDriverPriceInfo,
            buttons:[
              {text: strings.yes,onPress: () => { this.changePriceDriver(); }},
              {text: strings.no,onPress: () => { }},
              ],});

        }

        

      }},
      {text: strings.cancel, style:"cancel",onPress: () => {}}
      ],})

  }

  


  updateCreateClient = data => {

    console.log("le update de clients est appeler ")
    var uuid=generateUUID();

    var phone=(data.phone!=undefined && data.phone!="")?(data.countryPhoneIID+data.phone):undefined;

    var newClient={
      name:data.name,
      lastName:data.lastName,
      manualClient:true,
    }

    if(data.enterprise!=undefined && data.enterprise!="") newClient.enterprise=data.enterprise
    if(phone!=undefined) newClient.phone=phone
    if(data.email!=undefined && data.email!="") newClient.email=data.email
    if(data.adressBill!=undefined && data.adressBill!="") newClient.adressBill=data.adressBill
    if(data.cityBill!=undefined && data.cityBill!="") newClient.cityBill=data.cityBill

    const fireInfo={} 
    fireInfo["/users/"+uuid]=newClient; 
    fireInfo['race/' + this.state.id+"/createClientAlready"]=true; 
    update(ref(getDatabase(firebase)), fireInfo)

    this.setState({createClientAlready:true})
    this.alert.onAlert({title:strings.addClientOK});
    
  }

  changePriceDriver = data => {

    this.alert.onAlert({title:strings.priceSettings,textInput:{placeholder:((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+"40"+((this.state.money.position=="right")?(this.state.money.symbole):""),text:(this.state.forceDriverPrice!=undefined)?this.state.forceDriverPrice:"",sizeMultiplicator:2,detectSequencePosition:this.state.money.position,detectSequence:this.state.money.symbole,keyboardType:"numeric"},buttons:[
      {text: strings.validate,onPress: (value) => {
         var estg=value.toString().replace(this.state.money.symbole,'')
        estg=parseFloat(estg);

        if(!isNaN(estg) ){
          this.setState({forceDriverPrice:value, driverPlaceInfoAdmin:value})

          const fireInfo={} 
          fireInfo['race/' + this.state.id+"/forceDriverPrice"]=estg;
          update(ref(getDatabase(firebase)), fireInfo)

        }

        

      }},
      {text: strings.cancel, style:"cancel",onPress: () => {}}
      ],})


  }

  liveRaceGestion(){
    /*rajouter que si providerID!=undefined ... et qu'on a les SMS mailjet activé on start juste la course */

    
    if(this.state.raceInProgress==true) this.startLiveRace()
    else if(this.state.driver==true && this.state.attributedPartner!=undefined && this.state.attributedPartner.id!=getAuth(firebase).currentUser.uid) this.alert.onAlert({title:strings.warning,subTitle:strings.notDriverBecome,buttons:[  {text: strings.yes, onPress: () => { this.startLiveRace("takeDriver")  }}  ,{text: strings.no, style:"cancel",onPress: () => {  }} ],})
    else if((this.state.providerID!=undefined || this.state.customerPro==true ) && info.mailjetSMS!=false) this.startLiveRace()
    else if( (this.state.providerID!=undefined || this.state.customerPro==true) && this.state.karhooProvider!=true && this.state.clientPhone!=undefined && this.state.clientPhone!="" && (this.state.driver==true || (this.state.viewPhone=="always" || this.state.viewPhone=="onlyManualClient") )) this.alert.onAlert({title:strings.warning,subTitle:strings.manualRaceSMSWA,buttons:[  {text: strings.withSMS, onPress: () => { this.startLiveRace("SMS")  }}, {text: strings.withWhatsApp,onPress: () => {  this.startLiveRace("WhatsApp") }}  ,{text: strings.no,onPress: () => { this.startLiveRace()}} ],})
    else this.startLiveRace()
  }

  startLiveRace(action){
    var va=(this.state.raceInProgress==true)?false:true;
    var dateActu=Date.parse(new Date()); 

    if( (this.state.raceDate > (dateActu+86400000)) || (this.state.raceDate < (dateActu-86400000)) ){
        this.alert.onAlert({title:(this.state.raceDate > (dateActu+86400000))?strings.raceStartAfter:strings.raceStartBefore, subTitle:strings.raceStartABGeneral })  
      
    } else {
        const fireInfo={} 
        fireInfo['race/' + this.state.id+"/raceInProgress"]=va;
        if(this.state.raceInProgress!="pause") fireInfo['race/' + this.state.id+"/immediateMode"]="driverNavigateToCustomer";

      
        if(va==true) fireInfo['race/' + this.state.id+"/driverNavigateDate"]=Date.parse(new Date());

        if(action!=undefined){
          if(action=="takeDriver"){

            var attributedPartner={id:getAuth(firebase).currentUser.uid, text:this.state.actualUserName+" "+this.state.actualUserLastName}
            var attribCar=undefined;
            if(this.state.params.actualUserCar!=undefined){
                var listAUC=Object.keys(this.state.params.actualUserCar) 
                  attribCar=this.state.params.actualUserCar[listAUC[0]];
                  attributedPartner.car=attribCar;
            }

            this.setState({attributedPartner:attributedPartner,car:attribCar,driverPlaceInfoAdmin:false})
            fireInfo['race/' + this.state.id+"/attributedPartner"]=attributedPartner;
            fireInfo['race/' + this.state.id+"/driverPrice"]=null;
          }
          else if(action=="SMS") this.sendImCommingMessage("SMS")
          else if(action=="WhatsApp") this.sendImCommingMessage("WhatsApp")
    }
    
    update(ref(getDatabase(firebase)), fireInfo); 
    this.setState({raceInProgress:va});
    if(va==true) this.props.navigation.dispatch(CommonActions.reset({index: 0,routes: [{ name: 'Main' },],}) );

    }

  }


  viewPartner(){

      var selected=-1;
      var i;
      for(i=0;i<this.state.partnerList.length;i++){
          if(this.state.partnerList[i].id==this.state.attributedPartner.id) selected=i;
      }
      var partnerList=JSON.parse(JSON.stringify(this.state.partnerList));
     
      this.alert.onAlert({title:strings.attributedPartner, items:partnerList ,itemSelected:selected, buttons:[{text: strings.validate,onPress: (id,value) => {this.changePartner(partnerList[id]) }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  
      
       
  }

  viewCar(){
      var selected=-1;
      var i;
      for(i=0;i<this.state.actualUserCar.length;i++){
          if(JSON.stringify(this.state.params.actualUserCar[i])==JSON.stringify(this.state.car)) selected=i;
      }
      this.alert.onAlert({title:strings.car, items:this.state.actualUserCar ,itemSelected:selected, buttons:[{text: strings.validate,onPress: (id,value) => {this.updateCar(this.state.params.actualUserCar[id]) }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  
  }

  startAnimButton(){
      Animated.timing(this.shadowStartButton, {toValue: 2,duration: 1000, useNativeDriver: true}).start(({ finished }) => {
            Animated.timing(this.shadowStartButton, {toValue: 0.7,duration: 1000, useNativeDriver: true}).start()
        })

      Animated.timing(this.opacityStartButton, {toValue: 0,duration: 1000, useNativeDriver: true}).start(({ finished }) => {
        Animated.timing(this.opacityStartButton, {toValue: 0.3,duration: 1000, useNativeDriver: true}).start(({ finished }) => { this.startAnimButton() })
        })
  }


  startCheckStatus= (idRace) => {


    console.log("idRace "+idRace)
       var r=onValue(ref(getDatabase(firebase), '/race/'+idRace+"/status"), (value) => {

      var params=(this.props.route!=undefined)?this.props.route.params:this.props;     
      var val=value.val();
      console.log("le statut est ici ! "+val)
      console.log('/race/'+idRace+"/status"); 

      if(val==null) this.setState({missingRace:true})
      else if(val!=this.state.status) {
        if(params.nextWaitingRace!=undefined){
            if(this.props.route!=undefined) this.props.navigation.goBack();
            else this.props.goBack()}
        else this.setState({status:val})
        }
      })

      this.setState({searchStat:r});
  }

  componentDidMount(){

    timer.setTimeout("timerBut", () => { this.startAnimButton();}, 200);
    var params=(this.props.route!=undefined)?this.props.route.params:this.props;     
    this.startCheckStatus(this.state.id);
  }

  componentWillUnmount(){
    var r=this.state.searchStat;
    if(r!=undefined) r();
  }

  updateCar(info){

    this.setState({car:info})
    var params=(this.props.route!=undefined)?this.props.route.params:this.props;     

    const fireInfo={} 
    fireInfo['race/' + this.state.id+"/attributedPartner/car"]=info;
    update(ref(getDatabase(firebase)), fireInfo)

    if(params.updateData!=undefined){
      timer.setTimeout("timer3", () => {
        var params=(this.props.route!=undefined)?this.props.route.params:this.props;     
        params.updateData()}, 2000);
    }

  }

  recalculateDriverPrice(total, noSend, driverComm){
    if((noSend==true && this.state.driverPrice!=this.state.estimatePrice) || (noSend==true && this.state.driverPlaceInfoAdmin!=false && this.state.driverPlaceInfoAdmin!=undefined && this.state.driverPlaceInfoAdmin!=this.state.estimatePrice)   ||  this.state.params.billMode=="double" || ( (this.state.charge!=undefined || this.state.deferredPayment==true || this.state.karhooProvider==true) && this.state.params.billMode=="partnerCompany")){
      var driverPrice=parseFloat(total.toString().replace(this.state.money.symbole,''));
      
      if(this.state.params.pricingView.addCommissionFixe===true && this.state.params.pricingView.addCommissionFixeAmount>0) driverPrice-=this.state.params.pricingView.addCommissionFixeAmount;
      if(this.state.params.pricingView.addCommissionVariable===true && this.state.params.pricingView.addCommissionVariableAmount>0) driverPrice=driverPrice*((100-this.state.params.pricingView.addCommissionVariableAmount)/100);
      if(this.state.params.pricingView.commissionDriver>0) driverPrice=driverPrice*((100-this.state.params.pricingView.commissionDriver)/100);
      if(driverComm!=undefined) driverPrice=driverPrice*((100-driverComm)/100);
      driverPrice=driverPrice.toFixed(2);
      
      if(this.state.params.data.forceDriverPrice!=undefined) driverPrice=this.state.params.data.forceDriverPrice;
      driverPrice=((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+driverPrice+((this.state.money.position=="right")?(this.state.money.symbole):"");

      if(driverPrice!=this.state.estimatePrice) {
        const fireInfo={} 
        fireInfo['race/' + this.state.id+"/driverPrice"]=driverPrice;
        if(noSend!=true) update(ref(getDatabase(firebase)), fireInfo)
        if(this.state.driver==true) this.setState({driverPlaceInfoAdmin:driverPrice});
        else this.setState({driverPrice:driverPrice})
       }

    } else this.setState({driverPrice:total})
  }

  recalculatePrice= (data) => {
    
    getAuth(firebase).currentUser.getIdToken().then(token => {
        var body={raceID:this.state.id,
          date:this.state.raceDate,
          racePlaceStartName:this.state.racePlaceStartName.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
          carName:this.state.carName,
          token:token,
          taxiMode:this.state.taxiMode,
          userID:getAuth(firebase).currentUser.uid,
          raison:(this.state.driver==true)?"admin":"racePartner"
        }

        if(this.state.clientID!=undefined && this.state.clientID!="") body.clientID=this.state.clientID
        if(this.state.racePlaceEndName!=undefined && this.state.racePlaceEndName!="") body.racePlaceEndName=this.state.racePlaceEndName.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        else {

          body.racePlaceStartCoord={lat:this.state.markerProvision.latitude,lng:this.state.markerProvision.longitude}
          body.duration=this.state.estimateTimeValue}
        if(this.state.stopList!=undefined && this.state.stopList.length>0){
              
              var stopList=[];
              var stopListI;
              for(stopListI=0; stopListI<this.state.stopList.length; stopListI++){
                stopList.push(this.state.stopList[stopListI].normalize("NFD").replace(/[\u0300-\u036f]/g))
              }

              body.stopList=stopList;
          
        } 
        console.log(JSON.stringify(body))
        

        fetch("https://us-central1-"+info.firebaseProjectID+".cloudfunctions.net/recalculatePrice", {body: JSON.stringify(body),method: "POST"}).then(response => response.json()).then(responseJson => {
              console.log(responseJson);
              if(responseJson.quote!=undefined && responseJson.quote.total!=undefined){ 
                responseJson.quote.total/=100; 
                console.log("responseJson.quote.total "+responseJson.quote.total)
                if(this.state.noVAT==true) {
                  responseJson.quote.total/=(1+ ( (this.state.racePlaceEndName==undefined || this.state.racePlaceEndName=="")?info.tvaPercentDispo:info.tvaPercentClassic  ) /100) 
                  responseJson.quote.total=responseJson.quote.total.toFixed(2)
                }
                var newPrice=((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+responseJson.quote.total+((this.state.money.position=="right")?(this.state.money.symbole):"")
                newPrice=this.calculateOptionFee(newPrice)
                console.log("new Price = "+newPrice)

                  this.alert.onAlert({title:"Le nouveau prix pour cette course est :",textInput:{sizeMultiplicator:3,editable:false,text:newPrice}, buttons:[
                      {text: strings.confirm,onPress: () => { 
                        this.setState({estimateKm:(responseJson.km!=undefined)?responseJson.km.toFixed(2)+" km":this.state.estimateKm, estimateTimeValue:responseJson.time, estimatePrice:((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+responseJson.quote.total+((this.state.money.position=="right")?(this.state.money.symbole):""), change:true}) 
                        if(this.state.driver==true) this.alert.onAlert({title:strings.changePriceDriver, subTitle:strings.forceDriverPriceInfo,buttons:[{text: strings.yes,onPress: () => { this.changePriceDriver(); }},{text: strings.no,onPress: () => { }},],});
                        else this.recalculateDriverPrice(newPrice)
                    }},
                      {text: strings.cancel,style:"cancel", onPress: () => {  }} ]

                   })
              }
              else this.alert.onAlert({title:"Désolé aucun tarif n'a été trouvé"})

          }).catch((err) => { console.log("error recalculatePrice"); console.log(err); timer.setTimeout("recalculatePrice", () => { this.recalculatePrice(data);  }, 2000);   })

    })

  }

  onChangeQuestionPriceMaps= () => {
          var fetchURLparams={address:this.state.racePlaceStartName, key: info.googleMapsKey}
          var fetchURL=Qs.stringify(fetchURLparams)
          var getDir;
          if(Platform.OS=="web"){
            var body={paramsRqs:fetchURL, type:"geocode" }
            getDir=fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/getMapsInfo", {body: JSON.stringify(body),method: "POST"})
          }
          else getDir=fetch('https://maps.googleapis.com/maps/api/geocode/json?'+fetchURL) 

          getDir.then(response => response.json()).then(responseJson => {
          if(responseJson!=undefined && responseJson.results!=undefined && responseJson.results[0].geometry!=undefined){
            this.setState({markerProvision:{latitude:responseJson.results[0].geometry.location.lat,longitude:responseJson.results[0].geometry.location.lng} },() =>{this.recalculatePrice()})
          }
          else this.alert.onAlert({title:strings.errorDefault})


          }).catch((err) => { console.log("error onChangeQuestionPriceMaps"); console.log(err); timer.setTimeout("onChangeQuestionPriceMaps", () => { this.onChangeQuestionPriceMaps();  }, 2000);   })
        }


  onChangeQuestionPrice= () => {

   if(true) this.alert.onAlert({title:strings.trajetModifyCalcul,notClose:true,subTitle:strings.trajetModifyCalculWarning,buttons:[
      {text: strings.yes,onPress: () => { 
        this.alert.onAlert({title:strings.thankWaiting, subTitle:strings.calculRaceWait, waiting:true}); 

        if((this.state.racePlaceEndName==undefined || this.state.racePlaceEndName=="") && this.state.markerProvision==undefined) this.onChangeQuestionPriceMaps();
        else this.recalculatePrice() 

      }},
      {text: strings.no, onPress: () => { this.alert.forceClose() }}
    ],});

 }

  onPricePlaceFrom = (data) => {
    this.setState({racePlaceStartName: data.description,change:true})
    this.onChangeQuestionPrice()
   
  }

  onPricePlaceStop = (data,i, remove) => {
    var stopList
    if(this.state.stopList==undefined) stopList=[];
    else stopList=JSON.parse(JSON.stringify(this.state.stopList))
    if(remove!=true) stopList[i]=data.description;
    else stopList.splice(i, 1)
    this.setState({stopList:[] },() =>{ this.setState({stopList: stopList,change:true}) })
    
    this.onChangeQuestionPrice()
  }

  onPricePlaceTo = (data) => {
    this.setState({racePlaceEndName: data.description,change:true})
    this.onChangeQuestionPrice()

    /*if(this.state.karhooProvider==true){
      console.log("new destination") 
      console.log(data)
      firebase.database().ref('race/' + this.state.id).update({apiDestination:data})
    }*/

  }

  sendMessageToKarhoo= (data) => {

    this.alert.onAlert({title:strings.sendCommentKarhoo,textInput:{placeholder:strings.thankToWriteMessage,text:"", multiline:true},buttons:[

      {text: strings.send,onPress: (value) => {
            if(value!=""){
                  console.log("ici")
                  var date=date=new Date(this.state.raceDate)
                  date=((date.getDate()<10)?"0":"")+date.getDate()+"/"+(((date.getMonth()+1)<10)?"0":"")+(date.getMonth()+1)+"/"+date.getFullYear()+" à "+((date.getHours()<10)?"0":"")+date.getHours()+":"+((date.getMinutes()<10)?"0":"")+date.getMinutes()

                   var message= "Bonjour,<br>"+info.companyBrand+" dont l'identifiant de flotte est "+info.bundleIdentifer+" vous contacte au sujet de la course "; 
                   message+=(this.state.karhooAccountID!=undefined && karhooPartner[this.state.karhooAccountID]!=undefined)?(karhooPartner[this.state.karhooAccountID].name+" (id : "+this.state.karhooAccountID+") " ):""
                   message+="du "+date+" dont l'identifiant est la course est : "+this.state.id+".<br><br>Voici son message : "+value
                  
                  console.log(message)
                   getAuth(firebase).currentUser.getIdToken().then(token => {
                    var body={
                      userID:getAuth(firebase).currentUser.uid,
                      bundleIdentifer:info.bundleIdentifer,
                      message:message,
                      from: {Email: info.mavEmail,Name: info.companyBrand},
                      to: [{Email: "di.fazio@hotmail.fr",Name: "Karhoo"}], 
                      token:token,
                      subject:info.companyBrand+" rencontre un problème avec une course",
                      bundleAdress:info.firebaseProjectID,
                  }
                    console.log("je fais le fetch")
                    fetch("https://us-central1-mon-appli-vtc.cloudfunctions.net/sendEmail", {body: JSON.stringify(body),method: "POST"}).then((response) => response.json())
                  .then((responseJson) => {this.alert.onAlert({title:strings.messageHasBeenSend}); }).catch((err) => {this.alert.onAlert({title:strings.errorDefault}); })
                  
                  })      

            } else this.alert.onAlert({title:strings.thankToWriteMessage});
                       
      }},
       {text: strings.cancel, style:"cancel",onPress: () => {}}
    ],})

  }

  sendMessageToAdmin= (data) => {

        this.alert.onAlert({title:strings.sendCommentAdmin,textInput:{placeholder:strings.thankToWriteMessage,text:"", multiline:true},buttons:[
                    {text: strings.send,onPress: (value) => {
                      console.log(value)
                      if(value!=""){
                       
                        /*je mets à jour la course avec les infos */
                        const fireInfo={} 
                        fireInfo['race/' + this.state.id+"/driverMessage/"+Date.parse(new Date())]={text:value }
                        update(ref(getDatabase(firebase)), fireInfo)
                        
                        

                        /*j'envoi un mail aux admins */

                        getAuth(firebase).currentUser.getIdToken().then(token => {
                              var date=date=new Date(this.state.raceDate)
                              date=((date.getDate()<10)?"0":"")+date.getDate()+"/"+(((date.getMonth()+1)<10)?"0":"")+(date.getMonth()+1)+"/"+date.getFullYear()+" - "+((date.getHours()<10)?"0":"")+date.getHours()+":"+((date.getMinutes()<10)?"0":"")+date.getMinutes()

                              var message= "Bonjour, "+this.state.attributedPartner.text+" vous a envoyé un message à propos de la course du "+date+". Voici son message : "+value+". Vous pouvez aussi retrouver son message dans l'application ou dans l'interface web."
                              var body={
                                  userID:getAuth(firebase).currentUser.uid,
                                  bundleIdentifer:info.bundleIdentifer, 
                                  message:message,
                                  token:token,
                                  title:"Vous avez un message d'un chauffeur",
                                  bundleAdress:info.firebaseProjectID,
                                  onlyMessage:true,
                              }

                          console.log(JSON.stringify(body))
                          fetch("https://us-central1-"+info.firebaseProjectID+".cloudfunctions.net/sendMessageToAdmin", {
                                body:JSON.stringify(body),
                                method: "POST"})

                        })

                        this.alert.onAlert({title:strings.messageHasBeenSend});




                      } else this.alert.onAlert({title:strings.thankToWriteMessage});
                       
                    }},
                    {text: strings.cancel, style:"cancel",onPress: () => {}}
                    ],})
                      

  }


  changeSelectedOptions= (name, value, price) => {
    var selectedOptions=this.state.selectedOptions;
    if(selectedOptions==undefined) selectedOptions={}
    if(selectedOptions[name]==undefined) selectedOptions[name]={}
    selectedOptions[name]={value:value, price:price}; 

    this.setState({selectedOptions:selectedOptions, change:true},() =>{this.calculateOptionFee()})

  }

  calculateInitalOptionFee(price, selectedOptions, money){
      var amount=0
      var i; 
      var valueText=parseFloat(price.toString().replace(money.symbole,''));

      if(selectedOptions!=undefined && selectedOptions!=false){
          var selectedOptionsArray=Object.keys(selectedOptions); 
          for(i=0; i<selectedOptionsArray.length;i++){

          if(selectedOptions[selectedOptionsArray[i]].price!=undefined && selectedOptions[selectedOptionsArray[i]].price>0){
            var nombre=(selectedOptions[selectedOptionsArray[i]].value==true)?1:selectedOptions[selectedOptionsArray[i]].value
            if(selectedOptions[selectedOptionsArray[i]].value!=false) amount+=(selectedOptions[selectedOptionsArray[i]].price* nombre )
          }

      }


      }
      var final=((money.position=="left")?(money.symbole+" "):"")+(valueText-amount)+((money.position=="right")?(money.symbole):"")

      return final;
  
  }

  calculateOptionFee= (forceValue) => {

    console.log("calculateOptionFee demarre")
        var i;
        
        if(this.state.selectedOptions!=undefined && this.state.selectedOptions!=false){
          var selectedOptionsArray=Object.keys(this.state.selectedOptions); 
          var amount=0

          for(i=0; i<selectedOptionsArray.length;i++){

            if(this.state.selectedOptions[selectedOptionsArray[i]].price!=undefined && this.state.selectedOptions[selectedOptionsArray[i]].price>0){
              var nombre=(this.state.selectedOptions[selectedOptionsArray[i]].value==true)?1:this.state.selectedOptions[selectedOptionsArray[i]].value
              if(this.state.selectedOptions[selectedOptionsArray[i]].value!=false) amount+=(this.state.selectedOptions[selectedOptionsArray[i]].price* nombre )
            }

          }

            var valueText=this.state.originalPrice.toString().replace(this.state.money.symbole,'');
            if(forceValue!=undefined) valueText=forceValue.toString().replace(this.state.money.symbole,'');

            console.log("valueText ="+valueText)

            var n = valueText.indexOf("-");
            if(n!=-1){
                valueText=(parseFloat(valueText.split("-")[0])+amount)+"-"+(parseFloat(valueText.split("-")[1])+amount)
            }
            else valueText=parseFloat(valueText)+amount;

            valueText=((this.state.money.position=="left")?(this.state.money.symbole+" "):"")+valueText+((this.state.money.position=="right")?(this.state.money.symbole):"")

            if(forceValue!=undefined) return valueText;
            else {this.setState({estimatePrice:valueText})

            console.log("je vais faire le recalculateDriverPrice")
            if(this.state.driver==true && this.state.attributedPartner!=undefined && this.state.attributedPartner.id!=getAuth(firebase).currentUser.uid){
              /*je vais chercher la commission chauffeur */
              

              get(child(ref(getDatabase(firebase)), '/users/'+this.state.attributedPartner.id+'/commission')).then(value => {
                var val=value.val()
                if(val!=null) this.recalculateDriverPrice(valueText, true,val)
                else this.recalculateDriverPrice(valueText, true)
              })

            }
            else this.recalculateDriverPrice(valueText, true)

            }
          }

          else if(forceValue!=undefined) return forceValue;
  
  }

  changePartner(data){
      this.setState({purposeChange:false})
      var attribCar=undefined;

      if(data.id=="-1" || data.id==-1){this.getPartnersList()}
      else {
            if(data.id==getAuth(firebase).currentUser.uid && this.state.params.actualUserCar!=undefined){
              var listAUC=Object.keys(this.state.params.actualUserCar) 
              attribCar=this.state.params.actualUserCar[listAUC[0]];
              data.car=attribCar;
            }
            var oldAttributedPartner=(this.state.attributedPartner!=undefined && this.state.attributedPartner!="")?JSON.parse(JSON.stringify(this.state.attributedPartner)):undefined;

            this.setState({attributedPartner:data,car:attribCar,driverPlaceInfoAdmin:(this.state.forceDriverPrice!=undefined && data.id!=getAuth(firebase).currentUser.uid)?this.state.forceDriverPrice:false, })
            console.log("je suis ici")
            const fireInfo={} 
            fireInfo['race/' + this.state.id+"/attributedPartner"]=data
            fireInfo['race/' + this.state.id+"/driverPrice"]=null

            if(this.state.viewD==true || this.state.waitConfirmRace==true){

              /*je le supprime chez l'ancien*/
              fireInfo['users/' +oldAttributedPartner.id+"/confirmRace/"+this.state.id]=null

              fireInfo['race/' + this.state.id+"/viewD"]=null

              /*si c'est moi*/
              if(data.id===getAuth(firebase).currentUser.uid){
                fireInfo['race/' + this.state.id+"/waitConfirmRace"]=null
              }
              else{
                fireInfo['race/' + this.state.id+"/waitConfirmRace"]=true
                var elemS={raceDate:this.state.raceDate, racePlaceStartName:this.state.racePlaceStartName,  }
                if(this.state.racePlaceEndName!=undefined && this.state.racePlaceEndName!="") elemS.racePlaceEndName=this.state.racePlaceEndName  
                fireInfo['users/' +data.id+"/confirmRace/"+this.state.id]=elemS
              }
            }
            

            update(ref(getDatabase(firebase)), fireInfo)

            if(data.id!=getAuth(firebase).currentUser.uid) {
                  getAuth(firebase).currentUser.getIdToken().then(token => {
                  var body={
                      securisedTask:true,
                      userID:getAuth(firebase).currentUser.uid,
                      bundleIdentifer:info.bundleIdentifer,
                      message:"Une course vous a été attribué. Ouvrez l'appli pour en savoir plus",
                      clientID:data.id,
                      token:token,
                      title:"Nouvelle course pour le "+this.state.date,
                      bundleAdress:info.firebaseProjectID,
                  }
                  this.firebaseSendByMessage(body)
                  

                })

            }

            /*j'envoi un message à l'ancien pour dire que la course a été annulé*/
            if(oldAttributedPartner!=undefined && oldAttributedPartner.id!=getAuth(firebase).currentUser.uid){
              getAuth(firebase).currentUser.getIdToken().then(token => {
                var raceDate=new Date(this.state.raceDate)
                var today=new Date;
                 var dateTxt;
                if(raceDate.getDate()==today.getDate() && raceDate.getMonth()==today.getMonth() && raceDate.getFullYear()==today.getFullYear()) dateTxt="de "+((raceDate.getHours()<10)?"0":"")+raceDate.getHours()+":"+((raceDate.getMinutes()<10)?"0":"")+raceDate.getMinutes();
                else dateTxt="du "+((raceDate.getDate()<10)?"0":"")+raceDate.getDate()+"/"+(((raceDate.getMonth()+1)<10)?"0":"")+(raceDate.getMonth()+1)+"/"+raceDate.getFullYear()+" à "+((raceDate.getHours()<10)?"0":"")+raceDate.getHours()+":"+((raceDate.getMinutes()<10)?"0":"")+raceDate.getMinutes()

               

                  var body={
                      securisedTask:true,
                      userID:getAuth(firebase).currentUser.uid,
                      bundleIdentifer:info.bundleIdentifer,
                      message:"Votre course "+dateTxt+" a été annulé",
                      clientID:oldAttributedPartner.id,
                      token:token,
                      title:"Course annulée",
                      bundleAdress:info.firebaseProjectID,
                  }

                  this.firebaseSendByMessage(body)

                })
            }

            if(this.state.params.updateData!=undefined){
              timer.setTimeout("timer3", () => {this.state.params.updateData()}, 2000);
            }
          }
  }

  addTrainFlight = typeofRequest => { 
   this.alert.onAlert({title:(typeofRequest=="train")?strings.numeroTrain:strings.numeroFlight,textInput:{placeholder:"Numero",text:""},buttons:[

      {text: strings.send,onPress: (value) => {
            if(value!=""){

              if(typeofRequest=="train") this.setState({numTrain: value,change:true })
              else  this.setState({numFlight: value,change:true })

            } else this.alert.onAlert({title:strings.thankToWriteMessage});
                       
      }},
       {text: strings.cancel, style:"cancel",onPress: () => {}}
    ],})

 }



  firebaseSendByMail = bodyInfo => { 
    console.log("firebaseSendByMail launch")
      fetch("https://us-central1-"+info.firebaseProjectID+".cloudfunctions.net/sendByMail", {body: JSON.stringify(bodyInfo),method: "POST"}).then((response) => response.json())
                  .then((responseJson) => {}).catch((err) => { console.log("error firebaseSendByMail"); console.log(err); timer.setTimeout("firebaseSendByMail", () => { this.firebaseSendByMail(bodyInfo);  }, 2000);   })
                                
  }

  firebaseSendByMessage = bodyInfo => { 
    console.log("firebaseSendByMessage launch")
      fetch("https://us-central1-"+info.firebaseProjectID+".cloudfunctions.net/sendMessage", {body: JSON.stringify(bodyInfo),method: "POST"}).then((response) => response.json())
                  .then((responseJson) => {}).catch((err) => { console.log("error sendMessage"); console.log(err); timer.setTimeout("sendMessage", () => { this.sendMessage(bodyInfo);  }, 2000);   })
                                
  }

  paiementExplication= () => {

    var buttons=[{text: strings.ImUnderstand,onPress: (id,value) => { }}]
    if(this.state.driver==true && this.state.karhooProvider!=true && this.state.charge==undefined && this.state.withMyPOS!=true) buttons.push({text: strings.modify, bottomText:strings.paymentType, onPress: (id,value) => { this.changeStatutPayment() }})
    var textInfo= this.alert.onAlert({title:strings.infos, buttons:buttons, subTitle:((this.state.deferredPayment==true || this.state.karhooProvider==true || this.state.alreadyPaid==true)?strings.notPaidOnBoard: ( (this.state.charge==undefined && this.state.withMyPOS!=true)?strings.paidOnBoardMoreInfo: strings.paidCard )) })
  }

  changeStatutPayment= () => {
    var list=[{text:strings.notpaid, id:"notPaid"} ]
    if(this.state.clientID!=undefined) list.push({text:strings.deferredPayment, id:"deferredPayment"})
    list.push({text:strings.raceAlreadyPaid, id:"raceAlreadyPaid"})
      
    
    var selected=0;
    if(this.state.deferredPayment==true) selected=1; 
    else if(this.state.alreadyPaid==true) selected=(this.state.clientID!=undefined)?2:1;
    
     
      this.alert.onAlert({title:strings.carType, items:list ,itemSelected:selected, buttons:[{text: strings.validate,onPress: (id,value) => { 
        console.log(id) 
        const fireInfo={} 
        if(id==0){
          /*je supprime deferredPayment et alreadyPaid */
          fireInfo['race/' + this.state.id+"/deferredPayment"]=null
          fireInfo['race/' + this.state.id+"/alreadyPaid"]=null
          fireInfo['race/' + this.state.id+"/comOnly"]=null
          this.setState({deferredPayment:false, alreadyPaid:false})
        }
        else if(id==2 || (id==1 && (this.state.clientID==undefined) )){
          fireInfo['race/' + this.state.id+"/deferredPayment"]=null
          fireInfo['race/' + this.state.id+"/alreadyPaid"]=true
          fireInfo['race/' + this.state.id+"/alreadyPaidForce"]=true
          fireInfo['race/' + this.state.id+"/comOnly"]=null
          this.setState({deferredPayment:true, alreadyPaid:false})
        }
        else {
          fireInfo['race/' + this.state.id+"/deferredPayment"]=true
          fireInfo['race/' + this.state.id+"/alreadyPaid"]=false
          fireInfo['race/' + this.state.id+"/comOnly"]=null
          this.setState({deferredPayment:false, alreadyPaid:true})
        }

        update(ref(getDatabase(firebase)), fireInfo)

      }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  
      

    console.log("changeStatutPayment")



  }

  viewDebug = () => {
    var params=(this.props.route!=undefined)?this.props.route.params:this.props;
    this.setState({viewDebug:params.data});
    console.log(params.data);

  }

  changeCarName= () => {
      console.log("changeCarName")
      /*si c'est un trajet je charge princing si non je charge les mises à dispo */

      if(this.state.racePlaceEndName!=undefined && this.state.racePlaceEndName!=""){
        if(this.state.listVehicule!=undefined) this.changeCarNameNext(this.state.listVehicule)
        else {
          /*je les récupère */
          get(child(ref(getDatabase(firebase)), '/pricing')).then(value => {
              var val1=value.val();
              var val1array=Object.keys(val1)

              var carList={};
              var listVehicule=[];
                var i,j,pr,pra;
                if(val1!=null){
                  for(i=0;i<val1array.length;i++){
                      pr=val1[val1array[i]].price;
                      pra=Object.keys(pr)
                      for(j=0;j<pra.length;j++){
                          var name=pr[pra[j]].name;

                          if(val1[val1array[i]].taxiMode==true) name="TAXI - "+name;
                          carList[name]={text:name};
                      } 
                  } 
                  val1array=Object.keys(carList)
                  for(i=0; i<val1array.length;i++){
                      listVehicule.push({id:i, text:carList[val1array[i]].text})
                  }

                  this.changeCarNameNext(listVehicule);
                  this.setState({listVehicule:listVehicule})

                }
          })
        }
      }
      else {
        if(this.state.listVehiculeDispo!=undefined) this.changeCarNameNext(this.state.listVehiculeDispo)
        else {
          /*je les récupère */
          get(child(ref(getDatabase(firebase)), '/pricingProvision')).then(value => {
              var val2=value.val();
              var val2array=Object.keys(val2)

              var carList={};
              var listVehicule=[];
                var i,j,pr,pra;


                if(val2!=null){
                    var val2array=Object.keys(val2)
                    console.log(val2array)
                    for(i=0;i<val2array.length;i++){
                      console.log("je test = "+val2array[i])
                      if(val2array[i]=="typeZone"){
                            var k,l;
                            var tttot=val2[val2array[i]]; 
                            for(k=0;k<tttot.length;k++){
                                var listTttot=Object.keys(tttot[k].price)
                                for(l=0;l<listTttot.length;l++){
                                    carList[tttot[k].price[listTttot[l]].name]={text:tttot[k].price[listTttot[l]].name}
                                }
                            }
                        }
                        else{
                            carList[val2[val2array[i]].name]={text:val2[val2array[i]].name};
                        }
                        
                      }  

                      val2array=Object.keys(carList)
                        console.log(carList)
                        for(i=0; i<val2array.length;i++){
                            listVehicule.push({id:i, text:carList[val2array[i]].text})
                        }
                        this.changeCarNameNext(listVehicule);
                        this.setState({listVehiculeDispo:listVehicule})

                  }
          })
        }
      }
  }


  alertModif = () => {


 this.alert.onAlert({title:strings.alertModifMessage, subTitle:strings.alertModifMessageMoreInfo,textInput:{placeholder:strings.thankToWriteMessage,text:"", multiline:true},buttons:[

      {text: strings.send,onPress: (value) => {
            if(value!=""){ 

              this.setState({purposeChange:false})

                getAuth(firebase).currentUser.getIdToken().then(token => {
                      var body={securisedTask:true,userID:getAuth(firebase).currentUser.uid,bundleIdentifer:info.bundleIdentifer,message:value,clientID:this.state.attributedPartner.id,token:token,title:"Modification de course",bundleAdress:info.firebaseProjectID,}
                      this.firebaseSendByMessage(body)
                    })

            } else this.alert.onAlert({title:strings.thankToWriteMessage});
      }},
       {text: strings.cancel, style:"cancel",onPress: () => {}}
    ],})







 

  }

  changeCarNameNext = (listVehicule) => {

     var selected=-1;
      var i;
      for(i=0;i<listVehicule.length;i++){
          if(listVehicule[i].text==this.state.carName) selected=i;
      }
      var listVehicule=JSON.parse(JSON.stringify(listVehicule));
     
      this.alert.onAlert({title:strings.carType, items:listVehicule ,itemSelected:selected, buttons:[{text: strings.validate,onPress: (id,value) => {this.setState({carName:value, change:true }); this.onChangeQuestionPrice() }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  
      

  }

  changePassagerAdress = (key, choice, adress) => {

    /*je regarde les départs ou destination */
    var list=[]; 
    var list2=[];
    if(choice=="start") list.push(this.state.racePlaceStartName); 
    list=list.concat(this.state.stopList);
    if(choice=="end") list.push(this.state.racePlaceEndName); 

    var selected=-1;
    var i;
    for(i=0;i<list.length;i++){

        list2.push({text:(list[i].length>27)?(list[i].substring(0, 24)+"...") :list[i]}); 

        if(list[i]==adress) selected=i;
    }

    this.alert.onAlert({title:strings.adress, items:list2 ,itemSelected:selected, buttons:[{text: strings.validate,onPress: (id,value) => { 
       var passagersList=JSON.parse(JSON.stringify(this.state.passagersList))
        if(choice=="start") passagersList[key].start=list[id];
        else passagersList[key].end=list[id];
        this.setState({passagersList:passagersList, change:true })

    }},{text: strings.cancel, style:"cancel",onPress: () => {}}] })  
      

  }

  viewGenerateBill=() => {
      var data=this.state;
      data.noShow=true; 

      if(Platform.OS=="web") {
        var sendSee={data:data, commission:{ addCommissionFixe:false,addCommissionFixeAmount:0, addCommissionVariable:false,addCommissionVariableAmount:0,commissionDriver:0, calculateCommission:false }    }
        sendSee.goBack=(testClose) => {this.setState({seeGenerateBill:false}); if(testClose==true) this.props.goBack() };

        this.setState({seeGenerateBill:sendSee })
      }
      else this.props.navigation.navigate("GenerateBill",{data:data, commission:{ addCommissionFixe:this.state.params.pricingView.addCommissionFixe,addCommissionFixeAmount:this.state.params.pricingView.addCommissionFixeAmount, addCommissionVariable:this.state.params.pricingView.addCommissionVariable,addCommissionVariableAmount:this.state.params.pricingView.addCommissionVariableAmount,commissionDriver:this.state.params.pricingView.commissionDriver, calculateCommission:(this.state.params.billMode=="double" || ( (this.state.params.data.charge!=undefined || this.state.params.data.deferredPayment==true || this.state.params.data.karhooProvider==true || this.state.params.data.notBill==true) && this.state.params.billMode=="partnerCompany"))?true:false }    }); 
  }


  viewNoShowToKarhoo=() => {
      const fireInfo={} 
      fireInfo['race/' + this.state.id+"/noShow"]=true;
      fireInfo['race/' + this.state.id+"/cancelRaceDate"]=Date.parse(new Date());
      fireInfo['race/' + this.state.id+"/cancelRaceDriver"]=this.state.actualUserName+" "+this.state.actualUserLastName 
      fireInfo['race/' + this.state.id+"/status"]="cancel";

      update(ref(getDatabase(firebase)), fireInfo)
      this.alert.onAlert({title:strings.messageHasBeenSend});
  }

  viewHelpRace =() => {
      var send={}
      if(Platform.OS=="web") {send.goBack=() => {this.setState({seeHelpRace:false});}; this.setState({seeHelpRace:send}) } 
      else this.props.navigation.navigate("HelpRace",{params:this.state, modifyRace:this.modifyRaceFromHelp})

      } 

  seeGlobalChat =() => {
        var send={adminMode:true, noSend:(this.state.status=="waiting" || this.state.status=="invoiced" || this.state.karhooProvider==true || this.state.viaAPI==true  || this.state.status=="finish" || this.state.providerID!=undefined ||  this.state.raceProviderMode==true)?true:false, raceID:this.state.id, sender:this.state.clientName+" "+this.state.clientLastName, senderID:this.state.clientID, driverID:this.state.attributedPartner.id, driverName:this.state.attributedPartner.text }
        var service={};

        if(this.state.params.data.orderDate!=undefined){
          var viewDate=new Date(this.state.params.data.orderDate);
          viewDate=((viewDate.getDate()<10)?"0":"")+viewDate.getDate()+"/"+((viewDate.getMonth()<9)?"0":"")+(viewDate.getMonth()+1)+" | "+((viewDate.getHours()<10)?"0":"")+viewDate.getHours()+":"+((viewDate.getMinutes()<10)?"0":"")+viewDate.getMinutes()
          service[this.state.params.data.orderDate]={text:"- "+viewDate+" : "+strings.orderDate+" -", service:true};
        }

        if(this.state.params.data.validateDate!=undefined){
          var viewDate=new Date(this.state.params.data.validateDate);
          viewDate=((viewDate.getDate()<10)?"0":"")+viewDate.getDate()+"/"+((viewDate.getMonth()<9)?"0":"")+(viewDate.getMonth()+1)+" | "+((viewDate.getHours()<10)?"0":"")+viewDate.getHours()+":"+((viewDate.getMinutes()<10)?"0":"")+viewDate.getMinutes()
          service[this.state.params.data.validateDate]={text:"- "+viewDate+" : "+strings.validatedRace+" -", service:true};
        }

        if(this.state.params.data.cancelRaceDate!=undefined){
          var viewDate=new Date(this.state.params.data.cancelRaceDate);
          viewDate=((viewDate.getDate()<10)?"0":"")+viewDate.getDate()+"/"+((viewDate.getMonth()<9)?"0":"")+(viewDate.getMonth()+1)+" | "+((viewDate.getHours()<10)?"0":"")+viewDate.getHours()+":"+((viewDate.getMinutes()<10)?"0":"")+viewDate.getMinutes()
          service[this.state.params.data.cancelRaceDate]={text:"- "+viewDate+" : "+strings.raceHasBeenCanceled+( (this.state.noShow==true)?" no-show":"") +" ("+this.state.params.data.cancelRaceDriver+")" +" -", service:true};
        }


        
        if(this.state.params.data.driverNavigateDate!=undefined){
          var viewDate=new Date(this.state.params.data.driverNavigateDate);
          viewDate=((viewDate.getDate()<10)?"0":"")+viewDate.getDate()+"/"+((viewDate.getMonth()<9)?"0":"")+(viewDate.getMonth()+1)+" | "+((viewDate.getHours()<10)?"0":"")+viewDate.getHours()+":"+((viewDate.getMinutes()<10)?"0":"")+viewDate.getMinutes()
          service[this.state.params.data.driverNavigateDate]={text:"- "+viewDate+" : "+strings.start+" -", service:true};
        }

        if(this.state.params.data.arrivateDate!=undefined){
          var viewDate=new Date(this.state.params.data.arrivateDate);
          viewDate=((viewDate.getDate()<10)?"0":"")+viewDate.getDate()+"/"+((viewDate.getMonth()<9)?"0":"")+(viewDate.getMonth()+1)+" | "+((viewDate.getHours()<10)?"0":"")+viewDate.getHours()+":"+((viewDate.getMinutes()<10)?"0":"")+viewDate.getMinutes()
          service[this.state.params.data.arrivateDate]={text:"- "+viewDate+" : "+strings.driverIsPresent+" -", service:true};
        }

        if(this.state.params.data.realRaceDate!=undefined){
          var viewDate=new Date(this.state.params.data.realRaceDate);
          viewDate=((viewDate.getDate()<10)?"0":"")+viewDate.getDate()+"/"+((viewDate.getMonth()<9)?"0":"")+(viewDate.getMonth()+1)+" | "+((viewDate.getHours()<10)?"0":"")+viewDate.getHours()+":"+((viewDate.getMinutes()<10)?"0":"")+viewDate.getMinutes()
          service[this.state.params.data.realRaceDate]={text:"- "+viewDate+" : "+strings.customerOnBoard+" -", service:true};
        }


        if(this.state.params.data.realRaceDateReturn!=undefined){
          var viewDate=new Date(this.state.params.data.realRaceDateReturn);
          viewDate=((viewDate.getDate()<10)?"0":"")+viewDate.getDate()+"/"+((viewDate.getMonth()<9)?"0":"")+(viewDate.getMonth()+1)+" | "+((viewDate.getHours()<10)?"0":"")+viewDate.getHours()+":"+((viewDate.getMinutes()<10)?"0":"")+viewDate.getMinutes()
          service[this.state.params.data.realRaceDateReturn]={text:"- "+viewDate+" : "+strings.return+" -", service:true};
        }

        if(this.state.params.data.dropOffDate!=undefined){
          var viewDate=new Date(this.state.params.data.dropOffDate);
          viewDate=((viewDate.getDate()<10)?"0":"")+viewDate.getDate()+"/"+((viewDate.getMonth()<9)?"0":"")+(viewDate.getMonth()+1)+" | "+((viewDate.getHours()<10)?"0":"")+viewDate.getHours()+":"+((viewDate.getMinutes()<10)?"0":"")+viewDate.getMinutes()
          service[this.state.params.data.dropOffDate]={text:"- "+viewDate+" : "+strings.dropOffClient+" -", service:true};
        }

        if(this.state.params.data.cancelFromUserDate!=undefined){
          var viewDate=new Date(this.state.params.data.cancelFromUserDate);
          viewDate=((viewDate.getDate()<10)?"0":"")+viewDate.getDate()+"/"+((viewDate.getMonth()<9)?"0":"")+(viewDate.getMonth()+1)+" | "+((viewDate.getHours()<10)?"0":"")+viewDate.getHours()+":"+((viewDate.getMinutes()<10)?"0":"")+viewDate.getMinutes()
          service[this.state.params.data.cancelFromUserDate]={text:"- "+viewDate+" : "+strings.raceHasBeenCanceled+"("+strings.customer.toLowerCase()+") -", service:true};
        }

        if(this.state.params.data.cancelReason!=undefined){
          var viewDate=(this.state.params.data.cancelFromUserDate!=undefined)?new Date(this.state.params.data.cancelFromUserDate):new Date();
          viewDate=Date.parse(viewDate);
          service[viewDate]={text:"- "+ this.state.params.data.cancelReason +" -", service:true};
        }

        if(Object.keys(service).length>0) send.service=service;
        if(Platform.OS=="web") {send.goBack=() => {this.setState({seeChat:false});}; this.setState({seeChat:send}) } 
        else this.props.navigation.navigate("Chat",send)

  }

  viewSeeChat =() => {
    var send={raceID:this.state.id, sender:this.state.clientName+" "+this.state.clientLastName, senderID:this.state.clientID, driverID:getAuth(firebase).currentUser.uid, driverName:this.state.attributedPartner.text }
    if(Platform.OS=="web") {send.goBack=() => {this.setState({seeChat:false});}; this.setState({seeChat:send}) } 
    else this.props.navigation.navigate("Chat",send) 
  }

  viewBillGestion =() => {
     if(this.state.status!="invoiced" && this.state.status!="cancel") {

                    if(Platform.OS=="web") {
                      var sendSee={data:this.state, commission:{ addCommissionFixe:false,addCommissionFixeAmount:0, addCommissionVariable:false,addCommissionVariableAmount:0,commissionDriver:0, calculateCommission:false }    }
                      sendSee.goBack=(testClose) => {this.setState({seeGenerateBill:false}); if(testClose==true) this.props.goBack() };

                      this.setState({seeGenerateBill:sendSee })
                    }
                    else this.props.navigation.navigate("GenerateBill",{data:this.state, commission:{ addCommissionFixe:this.state.params.pricingView.addCommissionFixe,addCommissionFixeAmount:this.state.params.pricingView.addCommissionFixeAmount, addCommissionVariable:this.state.params.pricingView.addCommissionVariable,addCommissionVariableAmount:this.state.params.pricingView.addCommissionVariableAmount,commissionDriver:this.state.params.pricingView.commissionDriver, calculateCommission:(this.state.params.billMode=="double" || ( (this.state.params.data.charge!=undefined || this.state.params.data.deferredPayment==true || this.state.params.data.karhooProvider==true || this.state.params.data.notBill==true) && this.state.params.billMode=="partnerCompany"))?true:false }    }); 
                  

                  }
                  else {
                    if( (this.state.deferredPayment==true || this.state.karhooProvider==true || this.state.notBill==true) && this.state.deferredPaymentID==undefined && this.state.driver!=true){this.viewPDFFile("https://firebasestorage.googleapis.com/v0/b/"+info.storageBucket+"/o/bill%2F"+this.state.id+"%2F"+this.state.attributedPartner.id+".pdf?alt=media")}
                    else if(this.state.finalPriceDriverTTC!=undefined && this.state.driver==false && this.state.hidePriceRaceForDriver==true){this.viewPDFFile("https://firebasestorage.googleapis.com/v0/b/"+info.storageBucket+"/o/bill%2F"+this.state.id+"%2F"+this.state.attributedPartner.id+".pdf?alt=media")}
                    else if(this.state.finalPriceDriverTTC!=undefined){

                        if((this.state.deferredPayment==true || this.state.karhooProvider==true || this.state.notBill==true) && (this.state.deferredPaymentID==undefined || this.state.deferredPaymentID=="") )  this.viewPDFFile("https://firebasestorage.googleapis.com/v0/b/"+info.storageBucket+"/o/bill%2F"+this.state.id+"%2F"+this.state.attributedPartner.id+".pdf?alt=media")

                        else this.alert.onAlert({title:strings.whatBillyouSee,buttons:[
                          {text: strings.customer,onPress: () => {this.viewPDFFile("https://firebasestorage.googleapis.com/v0/b/"+info.storageBucket+"/o/bill%2F"+((this.state.deferredPaymentID!=undefined)?this.state.deferredPaymentID:this.state.id)+"%2Fbill.pdf?alt=media")}},
                          {text: strings.driver,onPress: () => {this.viewPDFFile("https://firebasestorage.googleapis.com/v0/b/"+info.storageBucket+"/o/bill%2F"+this.state.id+"%2F"+this.state.attributedPartner.id+".pdf?alt=media")}},
                          {text: strings.cancel,style:"cancel",onPress: () => {}}
                          ],});



                      }
                    else this.viewPDFFile("https://firebasestorage.googleapis.com/v0/b/"+info.storageBucket+"/o/bill%2F"+((this.state.deferredPaymentID!=undefined)?this.state.deferredPaymentID:this.state.id)+"%2Fbill.pdf?alt=media") 

                  }   
  }

  viewTheBDC= () => { 
      var pdfInfo=this.generatePDFInfo(); this.setState({pdfInfo:pdfInfo},() =>{ var infoOrder=JSON.parse(JSON.stringify(this.state)); if(!(this.state.clientPhone!=undefined && this.state.clientPhone!="" && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.viewPhone=="always" || (this.state.viewPhone=="onlyManualClient" && (this.state.customerPro==true || this.state.providerID!=undefined)) ))))) {infoOrder.clientPhone=info.companyPhone; };  infoOrder.description+=" "+infoOrder.carName; this.props.navigation.navigate("Order",infoOrder)  }) 
    }
  
  viewRemoveRace= () => { 
        this.alert.onAlert({title:strings.cancelRace,subTitle:strings.sureCancelRace,buttons:[
          {text: strings.yes,onPress: () => { this.sendRemoveRace(true);}},
          {text: strings.cancel,style:"cancel", onPress: () => { }}
        ],});
  }

  viewQRCode= () => { 
        var qrInfo={url:(info.trackLink+"/?trackLink="+this.state.id) };
        qrInfo.date=this.state.date;
        if(this.state.clientPhone!=undefined && this.state.clientPhone!="" && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.viewPhone=="always" || (this.state.viewPhone=="onlyManualClient" && (this.state.customerPro==true || this.state.providerID!=undefined)) )))) qrInfo.phone=this.state.phone; 
        
        if(Platform.OS=="web") {Clipboard.setString(qrInfo.url);this.alert.onAlert({title:strings.copiedClipboard,})}
        else this.qrCode.onPicker(qrInfo);
      }


    viewCancelRace= () => { 

        var titleCancel=strings.cancelRace; 
        var messCancel=strings.sureCancelRace; 
        if(this.state.karhooProvider==true) {
          titleCancel=strings.sureCancelRace; 
          messCancel=strings.sureCancelRaceKarhoo
        }
        this.alert.onAlert({title:titleCancel,subTitle:messCancel,buttons:[
              {text: strings.yes,onPress: () => { this.sendRemoveRace();}},
              {text: strings.no,style:"cancel", onPress: () => { }}
            ],});
      }


  viewDoubt= () => { 

    if(this.state.doubtInfo!=undefined){
        this.setState({viewDoubt:true})
    } else {
      get(child(ref(getDatabase(firebase)), '/doubt/'+this.state.id)).then(value => {
        console.log(value)
        var val=value.val(); 
        if(val!=null) { 

        
        if(val.pos!=undefined){

          var points=[];
          points.push({latitude: val.pos.latitude + (parseFloat(val.pos.accuracy) / 637800) * (180 / Math.PI)*1.01,longitude: val.pos.longitude - 1.01*(parseFloat(val.pos.accuracy) / 637800) * (180 / Math.PI) / Math.cos(val.pos.latitude * Math.PI/180)})
          points.push({latitude: val.pos.latitude - (parseFloat(val.pos.accuracy) / 637800) * (180 / Math.PI)*1.01,longitude: val.pos.longitude + 1.01*(parseFloat(val.pos.accuracy) / 637800) * (180 / Math.PI) / Math.cos(val.pos.latitude * Math.PI/180)})
        
          val.regionZoom=this.calculateRegionZoom(points);

        }
        this.setState({doubtInfo:val, viewDoubt:true})
        }

      })
    } 
  }

  forceDeffered = () => { 
    
    if(this.state.clientID!=undefined && this.state.clientID!="") {
      const fireInfo={} 
      fireInfo['race/' + this.state.id+"/deferredPayment"]=true
      update(ref(getDatabase(firebase)), fireInfo)
      this.setState({deferredPayment:true})
    }
    else this.alert.onAlert({title:"identifiant du client", textInput:{placeholder:"id",text:""},buttons:[{text: strings.validate,onPress: (value) => { 
        const fireInfo={} 
        fireInfo['race/' + this.state.id+"/deferredPayment"]=true
        fireInfo['race/' + this.state.id+"/clientID"]=value
        update(ref(getDatabase(firebase)), fireInfo)
        this.setState({clientID:value,deferredPayment:true}) 

     }}]})
                       
  }




  render() {
    this.opacityStartButton = new Animated.Value(0.3);
    this.shadowStartButton = new Animated.Value(0.7);

    return (
      <StyleContext.Consumer>{style => 

        <View style={{flex:1,backgroundColor:style.backgroundColor}} >

        


        {this.state.missingRace==true && <View style={{alignItems:"center", marginTop:20 }}>
              <Image source={(style.mode=="dark")?require('../assets/driver_cancel_light.png'):require('../assets/driver_cancel_dark.png')} style={{marginBottom:10,height:40,width:40,resizeMode:"contain"}}/>

              <Text style={{color:style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",fontWeight: 'bold'}}>{strings.raceRemoved}</Text>
        </View>}
        
        {this.state.missingRace==false && <ScrollView style={{flex:1,backgroundColor:style.backgroundColor}}> 


        {info.debugMAV==true && <View>

          <TouchableHighlight style={{marginTop:10, height:20, backgroundColor:"#FF0000", alignItems:"center"}} underlayColor={'#FFFFFF00'} onPress={() => { 
            const fireInfo={} 
            fireInfo['race/' + this.state.id+"/status"]="ee"
            update(ref(getDatabase(firebase)), fireInfo)

            timer.setTimeout("timerStat", () => {
              const fireInfo={} 
              fireInfo['race/' + this.state.id+"/status"]="WaitingInvoice"
              fireInfo['race/' + this.state.id+"/newEdition"]=true
              update(ref(getDatabase(firebase)), fireInfo);}, 2000); 

          }}>
                <Text style={{color:style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>Regénérer la facture</Text>
          </TouchableHighlight>


          <TouchableHighlight style={{marginTop:10, height:20, backgroundColor:"#FF0000", alignItems:"center"}} underlayColor={'#FFFFFF00'} onPress={() => { 
            const fireInfo={}  
            fireInfo['race/' + this.state.id+"/deferredPaymentID"]=null
            update(ref(getDatabase(firebase)), fireInfo)

           

          }}>
                <Text style={{color:style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>Supprimer id facture différé</Text>
          </TouchableHighlight>



          {(this.state.viewDebug==undefined && this.state.deferredPayment!=true) && <TouchableHighlight style={{backgroundColor:"#FF0000", marginTop:10, height:20, alignItems:"center"}} underlayColor={'#FFFFFF00'} onPress={() => { this.forceDeffered()   }}>
                <Text style={{color:style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>Paiement différé</Text>
          </TouchableHighlight>}

          {this.state.viewDebug==undefined && <TouchableHighlight style={{backgroundColor:"#FF0000", marginTop:10, height:20, alignItems:"center"}} underlayColor={'#FFFFFF00'} onPress={() => { this.viewDebug()  }}>
                <Text style={{color:style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",}}>Voir le debug</Text>
          </TouchableHighlight>}

          

          {this.state.viewDebug!=undefined && <TextPresentation defautVisible={true} text={"Debug des infos"} icon={require('../assets/warning.png')} >
                {Object.keys(this.state.viewDebug).map((rowData,id) => ( <View>
                      {typeof(this.state.viewDebug[rowData])!="object" && <TextPresentation style={{marginTop:5}} textInputFlex={1.5} textExplication={rowData} text={ this.state.viewDebug[rowData] } editable={false} /> }
                      
                      {typeof(this.state.viewDebug[rowData])=="object" && <TextPresentation style={{marginTop:5}} textExplication={rowData} text={""} editable={false} /> }
                      {typeof(this.state.viewDebug[rowData])=="object" && Object.keys(this.state.viewDebug[rowData]).map((rowDataBis,idBis) => ( <View>
                            
                            <TextPresentation style={{marginTop:5, marginLeft:15}} textInputFlex={1.5} textExplication={rowDataBis} text={ (typeof(this.state.viewDebug[rowData])=="object")?JSON.stringify(this.state.viewDebug[rowData][rowDataBis]): this.state.viewDebug[rowData][rowDataBis] } editable={false} /> 
                        
                        </View>))}

                 </View> ))}


          </TextPresentation>}


        </View>}





        {(this.state.status=="cancel" || this.state.userRequestAnnulation==true) && <View style={{width:"100%", height:50, backgroundColor:style.colorNotification, alignItems:"center", justifyContent:"center", shadowOpacity: 1, shadowColor:style.backgroundColorContrast, shadowRadius: 2,shadowOffset: {height: 1,width: 0},elevation: 1 }}>
            <Text style={{color:"#FFFFFF", fontSize: style.textInputFontSize*((this.state.userRequestAnnulation==true)?1.2:1.4),textAlign: "center",fontWeight: 'bold'}}>{(this.state.userRequestAnnulation==true && this.state.status=="validate")?strings.userRequestAnnulation:strings.raceHasBeenCanceled}</Text>
        </View>}
        






          {(this.state.modify!=undefined && this.state.status=="validate" && this.state.raceProviderMode!=true && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance"))  ) ) && <TextPresentation modification={true}  marginSize={"5%"} defautVisible={true} text={ strings.requestModifWait } icon={require('../assets/warning_orange.png')} >


               {(this.state.modify.clientName!=undefined || this.state.modify.clientLastName!=undefined) && <TextPresentation icon={require('../assets/user_black.png')} textExplication={strings.principalCustomer} editable={false} textRightRemoved={true}  textRight={this.state.clientName+" "+this.state.clientLastName} text={((this.state.modify.clientName!=undefined)?this.state.modify.clientName:this.state.clientName)+" "+((this.state.modify.clientLastName!=undefined)?this.state.modify.clientLastName:this.state.clientLastName) } />}


               {this.state.modify.passagersList!=undefined && this.state.modify.passagersList.map((rowData,id) => ( <View>

                  {(rowData!="removed") && <TextPresentation icon={require('../assets/user_black.png')} textExplication={strings.traveler}  editable={false} textRightRemoved={true}  textRight={this.state.passagersList[id].name+" "+this.state.passagersList[id].lastName} text={((rowData.name!=undefined)?rowData.name:this.state.passagersList[id].name)+" "+((rowData.lastName!=undefined)?rowData.lastName:this.state.passagersList[id].lastName)} />}
                  {(rowData=="removed") && <TextPresentation icon={require('../assets/user_black.png')} textExplication={strings.traveler}  editable={false} textRightRemoved={true}  textRight={true} text={this.state.passagersList[id].name+" "+this.state.passagersList[id].lastName} />}

                  
                  </View>
                ))}



              {this.state.modify.raceDate!=undefined && <TextPresentation textExplication={strings.dateAndHour} icon={require('../assets/calendar_black.png')} editable={false} textRightRemoved={true}   textRight={this.state.date} text={((new Date(this.state.modify.raceDate).getDate()<10)?"0":"")+  new Date(this.state.modify.raceDate).getDate()+"/"+((new Date(this.state.modify.raceDate).getMonth()<9)?"0":"")+ (new Date(this.state.modify.raceDate).getMonth()+1)+"/"+new Date(this.state.modify.raceDate).getFullYear()+" - "+((new Date(this.state.modify.raceDate).getHours()<10)?"0":"")+  new Date(this.state.modify.raceDate).getHours()+":"+((new Date(this.state.modify.raceDate).getMinutes()<10)?"0":"")+  new Date(this.state.modify.raceDate).getMinutes()} />}
              


               {(this.state.modify.racePlaceStartName!=undefined || this.state.modify.stopList!=undefined || this.state.modify.racePlaceEndName!=undefined) && <View style={{marginLeft:'5%', marginRight:'5%',marginBottom:15,marginTop:15}} > 
                    <RaceTrajetInfo estimateTimeValue={this.state.estimateTimeValue}  modifyPath={true} oldRacePlaceEndName={(this.state.modify.racePlaceEndName!=undefined)?this.state.racePlaceEndName:undefined} oldRacePlaceStartName={(this.state.modify.racePlaceStartName!=undefined)?this.state.racePlaceStartName:undefined} racePlaceEndName={(this.state.modify.racePlaceEndName!=undefined)?this.state.modify.racePlaceEndName:this.state.racePlaceEndName} oldStopList={(this.state.modify.stopList!=undefined)?this.state.stopList:undefined}  stopList={(this.state.modify.stopList!=undefined)?this.state.modify.stopList:this.state.stopList} color={"#000000"} racePlaceStartName={(this.state.modify.racePlaceStartName!=undefined)?this.state.modify.racePlaceStartName:this.state.racePlaceStartName}  disable={true} /> 
                </View>}

              {this.state.modify.description!=undefined && <TextPresentation textExplication={strings.description} text={this.state.modify.description} editable={false} multiline={true} icon={require('../assets/description_black.png')}  />}


                <View style={{width: "100%",alignItems:"center",justifyContent:"center",marginTop:10, flexDirection:"row", }}>
                      
                      <MavMiniButton icon={require('../assets/checkBasic_white.png')} color={"#000000"} colorText={"#000000"} text={strings.accept} style={{marginRight:15}} onPress={()=>{ this.modifyRaceDecision(true)  }}/>
                      <MavMiniButton icon={require('../assets/close_mini_white.png')} color={"#000000"} colorText={"#000000"} text={strings.decline} style={{marginLeft:15}} onPress={()=>{ this.modifyRaceDecision(false) }}/>
                </View>


        
        </TextPresentation>}



        {(this.state.raceProviderMode==true) && <TextPresentation colorYellow={true} textExplicationMultiLine={true} textExplication={( (this.state.providerID!=undefined && this.state.providerID!="" )?strings.yourRaceButNotDriver:strings.notYourRaceButFavorite)} text={""} editable={false} icon={require('../assets/warning_yellow.png')}  />}

        {this.state.letaxiProvider!=true && <TextPresentation style={{marginTop:5}}  disableChild={true}  onEditClick={()=>{ this.setState({viewClientDetail:!this.state.viewClientDetail}) }}   viewEdit={(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" &&  (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance"))  ))} icon={(style.mode=="light")?require('../assets/user_black.png'):require('../assets/user_white.png')} textExplication={( (this.state.cpam==true)?strings.raceCPAM : ((this.state.taxiMode==true)?strings.raceTaxiFor :(((this.state.racePlaceEndNameTest=="" || this.state.racePlaceEndNameTest==undefined)?strings.ProvisionFor:strings.bookingOf))) )} editable={false} textRightRemoved={true}  text={((this.state.clientName!=undefined)?(this.state.clientName+" "):"")+((this.state.clientLastName!=undefined)?this.state.clientLastName:"")} 
            elementRight={ <View>
                  {this.state.viewClientDetail!=true && <View style={{flexDirection:"row",alignItems:"center", justifyContent:"center" }} >
                        {this.state.vip==true && <View style={{width:40, marginRight:7, height:20, borderColor:style.textInputColor, borderWidth:1,alignItems:"center", justifyContent:"center", borderRadius:5}}><Text style={{ fontSize: 12, color: style.textInputColor,backgroundColor: 'rgba(0,0,0,0)', }}>{strings.vip.toUpperCase()}</Text></View>}
                        {(this.state.luggage!=undefined && this.state.luggage>0) && <Image source={(style.mode=="light")?require('../assets/luggage_black.png'):require('../assets/luggage_white.png')} style={{height:13,width:13,resizeMode:"contain", }}/>}
                        {(this.state.luggage!=undefined && this.state.luggage>0) && <Text style={{marginLeft:2, color: style.textInputColor,fontSize: style.textInputFontSize*0.9,textAlign: "center",fontWeight: 'bold'}}>{"x"+this.state.luggage}</Text>}

                        {(this.state.passagers!=undefined && this.state.passagers>0) && <Image source={(style.mode=="light")?require('../assets/user_black.png'):require('../assets/user_white.png')} style={{marginLeft:5, height:13,width:13,resizeMode:"contain", }}/>}
                        {(this.state.passagers!=undefined && this.state.passagers>0) && <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize*0.9,textAlign: "center",fontWeight: 'bold'}}>{"x"+this.state.passagers}</Text>}

                    </View>}

                    {this.state.viewClientDetail==true && <View style={{flexDirection:"row"}}>

                      {(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" &&  (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance"))  )) && <MavMiniButton  minimize={true} icon={(style.mode=="dark")?require('../assets/plus_black.png'):require('../assets/plus_white.png')} text={strings.add} onlyButton={true} style={{marginRight:10}} onPress={()=>{ var passagersList=this.state.passagersList; if(passagersList==undefined) passagersList=[]; passagersList.push({name:"", lastName:""}); this.setState({passagersList:passagersList,change:true, passagers:passagersList.length+1 })   }} />}
                      
                      <MavMiniButton  minimize={true} icon={(style.mode=="dark")?require('../assets/close_black.png'):require('../assets/close_white.png')} text={strings.close} onlyButton={true}  onPress={()=>{ this.setState({viewClientDetail:false})  }} />
                      
                      </View> }

                  </View>  }
        />}

        {(this.state.viewClientDetail==true) && <TextPresentation defautVisible={true} style={{marginLeft:(this.state.passagersList.length>0)?"5%":undefined, marginRight:(this.state.passagersList.length>0)?"5%":undefined}} hideTopbar={(this.state.passagersList.length>0)?false:true} icon={(style.mode=="light")?require('../assets/user_black.png'):require('../assets/user_white.png')} editable={false} minimizeTopBar={true} text={((this.state.clientName!=undefined)?(this.state.clientName+" "):"")+((this.state.clientLastName!=undefined)?this.state.clientLastName:"")} >

                                <TextPresentation style={{marginTop:15}}  text={this.state.clientName} textExplication={strings.name} editable={(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" &&  (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance"))  ))} placeholder={example.name} onChangeText={(text)=>{this.setState({clientName: text,change:true })}}
                                    elementRight={ (this.state.clientNote!=undefined)?<View style={{ flexDirection:"row" }}>
                                        <Image source={(style.mode=="light")?require('../assets/star1.png'):require('../assets/star1_dark.png')} style={{height:13,width:13,resizeMode:"contain", }}/>
                                        <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize*0.9,textAlign: "center",fontWeight: 'bold'}}>{this.state.clientNote.note+" - "+this.state.clientNote.reviews+" "+strings.reviews.toLowerCase()}</Text>
                                    </View>:undefined}
                                />

                                <TextPresentation style={{marginTop:5}} text={this.state.clientLastName}  textExplication={strings.lastName} editable={(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" &&  (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance"))  ))}  placeholder={example.lastName} onChangeText={(text)=>{this.setState({clientLastName: text,change:true })}}/>

                                {(this.state.clientPhone!=undefined && this.state.raceProviderMode!=true && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.viewPhone=="always" || (this.state.viewPhone=="onlyManualClient" && (this.state.customerPro==true || this.state.providerID!=undefined)) ) ))) && <TextPresentation editable={(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish"  && this.state.status!="cancel" && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance"))  ) )} style={{marginTop:5}}  text={this.state.clientPhone} textExplication={strings.phone} placeholder={example.phone}  onChangeText={(text)=>{this.setState({clientPhone: text,change:true })}}  />}
                          

                                {((this.state.clientEnterprise!=undefined && this.state.clientEnterprise!="") || (this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" && this.state.params.driver==true) ) && <TextPresentation suggestions={(info.countryCode=="fr")?"enterprise":undefined} style={{marginTop:5}} text={(this.state.clientEnterprise!=undefined)?this.state.clientEnterprise:""} textExplication={strings.enterprise} editable={(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel") && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance"))  )} placeholder={example.company} onChangeText={(text)=>{this.setState({clientEnterprise: text,change:true })}} onSuggestion={(value)=>{ this.setState({clientEnterprise: value.name, change:true }) ; if(!(this.state.customerPro==true || this.state.providerBill==true || this.state.deferredPayment==true)) this.setState({clientAdressBill:value.adress, clientCityBill:value.city }) }}/>}


                                {(((this.state.clientAdressBill!=undefined && this.state.clientAdressBill!="") || (this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel")) && this.state.params.driver==true && !(this.state.customerPro==true || this.state.providerBill==true || this.state.deferredPayment==true)  ) && <TextPresentation style={{marginTop:5}} text={(this.state.clientAdressBill!=undefined)?this.state.clientAdressBill:""} textExplication={strings.adressBill} editable={(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel") && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance"))  )} placeholder={example.adress} onChangeText={(text)=>{this.setState({clientAdressBill: text,change:true })}}         />}

                                {(((this.state.clientCityBill!=undefined && this.state.clientCityBill!="") || (this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel")) && this.state.params.driver==true && !(this.state.customerPro==true || this.state.providerBill==true || this.state.deferredPayment==true) ) && <TextPresentation style={{marginTop:5}} text={(this.state.clientCityBill!=undefined)?this.state.clientCityBill:""} textExplication={strings.cityBill} editable={(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel") && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance"))  )} placeholder={info.companyCity} onChangeText={(text)=>{this.setState({clientCityBill: text,change:true })}}/>}

                                {(this.state.clientID=="" || this.state.clientID==undefined && Platform.OS!="web" && this.state.createClientAlready!=true && this.state.driver==true) && <View style={{width:"100%", alignItems:"center", justifyContent:"center", marginTop:5}}> 
                                <MavButton onlyButton={true} small={true} text={strings.createAccount} style={{marginRight:5}} onPress={()=>{
                                    var prefill={}
                                    if(this.state.clientName!=undefined) prefill.name=this.state.clientName;
                                    if(this.state.clientLastName!=undefined) prefill.lastName=this.state.clientLastName;
                                    if(this.state.clientPhone!=undefined) prefill.phone=this.state.clientPhone;
                                    if(this.state.clientEmail!=undefined) prefill.email=this.state.clientEmail;
                                    if(this.state.clientEnterprise!=undefined) prefill.enterprise=this.state.clientEnterprise;
                                    if(this.state.clientAdressBill!=undefined) prefill.adress=this.state.clientAdressBill;
                                    if(this.state.clientCityBill!=undefined) prefill.city=this.state.clientCityBill;
                                 this.props.navigation.navigate('Account', {newClient: true, prefill:prefill, update:this.updateCreateClient }) }}/>
                                </View>} 






        </TextPresentation>}


        {(this.state.viewClientDetail==true && this.state.passagersList.length>0) && this.state.passagersList.map((rowData, key) => (<View>


                              <TextPresentation minimizeTopBar={true} style={{marginLeft:"5%", marginRight:"5%", marginTop:5}} text={ (rowData.name!="" && rowData.lastName!="")?(rowData.name+" "+rowData.lastName):(strings.customer+" "+(key+2)) } icon={(style.mode=="dark")?require('../assets/user_white.png'):require('../assets/user_black.png')} >

                                  <TextPresentation style={{marginTop:15}}  text={rowData.name} textExplication={strings.name} editable={(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" &&  (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance"))  ))}  backgroundColor={style.backgroundColorContrast} placeholder={example.name} onChangeText={(text)=>{var passagersList=this.state.passagersList; passagersList[key].name=text;      this.setState({passagersList:passagersList,change:true })   }}/>
                                  <TextPresentation style={{marginTop:5}}  text={rowData.lastName} editable={(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" &&  (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance"))  ))} disableLine={(this.state.stopList==undefined || this.state.stopList.length==0)?true:false} textExplication={strings.lastName}   placeholder={example.lastName} onChangeText={(text)=>{var passagersList=this.state.passagersList; passagersList[key].lastName=text;      this.setState({passagersList:passagersList,change:true })   }}/>

                                  {(rowData.phone!=undefined && this.state.raceProviderMode!=true && Platform.OS!="web" && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.viewPhone=="always" || (this.state.viewPhone=="onlyManualClient" && (this.state.customerPro==true || this.state.providerID!=undefined)) ) ))) && <TextPresentation style={{marginTop:15}}  text={(rowData.phone!=undefined)?rowData.phone:""} textExplication={strings.phone} editable={(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" &&  (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance"))  ))}   placeholder={example.phone} onChangeText={(text)=>{var passagersList=this.state.passagersList; passagersList[key].phone=text;      this.setState({passagersList:passagersList,change:true })   }}
                                      elementRight={(rowData.phone!=undefined)?<TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => { Linking.openURL("tel:"+rowData.phone); }}> 
                                          <View style={{flexDirection:"row", }} >
                                            <Image source={(style.mode=="dark")?require('../assets/driver_phone_light.png'):require('../assets/driver_phone_dark.png')} style={{height:20,width:20,resizeMode:"contain", }}/>
                                          </View>
                                        </TouchableHighlight>:undefined}


                                  /> }   


                                  {(this.state.stopList!=undefined && this.state.stopList.length>0) && <View style={{marginLeft:"5%", marginRight:"5%", marginTop:15}}>

                                        <RaceTrajetInfo 
                                            racePlaceEndName={(rowData.end!=undefined)?rowData.end:this.state.racePlaceEndName } 
                                            clickOnFrom={() => {if(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" &&  (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance"))  )) this.changePassagerAdress(key, "start", (rowData.start!=undefined)?rowData.start:this.state.racePlaceStartName ) }}
                                            clickOnTo ={() => {if(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" &&  (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance"))  )) this.changePassagerAdress(key, "end", (rowData.end!=undefined)?rowData.end:this.state.racePlaceEndName ) }}
                                            racePlaceStartName={(rowData.start!=undefined)?rowData.start:this.state.racePlaceStartName} 
                                            disable={ !(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" &&  (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance"))  )) } />
                                  </View>}


                                  <View style={{width:"100%", alignItems:"center", justifyContent:"center", marginTop:5}}> 
                                    <MavButton onlyButton={true} small={true} text={strings.remove} style={{marginRight:5}} onPress={()=>{
                                        var passagersList=this.state.passagersList; passagersList.splice(key,1); this.setState({passagersList:passagersList,change:true, passagers:passagersList.length+1 }) 
                                    
                                    }}/>
                                </View>



                              </TextPresentation>


                            </View>
                              

          ))}


          {((this.state.customerPro==true || this.state.providerID!=undefined) && (this.state.driver==true || this.state.viewPartnerForDrivers==true)) && <TextPresentation disableChild={this.state.driver!=true} textExplication={strings.provider} icon={(this.state.customerPro==true)?((style.mode=="light")?require('../assets/user_pro_black.png'):require('../assets/user_pro_white.png')):((style.mode=="light")?require('../assets/user_partner_black.png'):require('../assets/user_partner_white.png'))} editable={false} text={(this.state.viaAPI==true)?"API": ((this.state.providerEnterprise!=undefined && this.state.providerEnterprise!="")?this.state.providerEnterprise:(this.state.providerName+" "+this.state.providerLastName))} >

              <TextPresentation style={{marginTop:15}} onLock={()=>{ this.alert.onAlert({title:strings.lockProviderInfo, subTitle:strings.lockProviderInfoMoreInfo}) }} viewLock={(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" && this.state.params.driver==true && this.state.deferredPayment==true)} text={this.state.providerName} textExplication={strings.name} editable={(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" && this.state.params.driver==true && this.state.deferredPayment!=true)} placeholder={example.name} onChangeText={(text)=>{this.setState({providerName: text,change:true })}} />

              <TextPresentation style={{marginTop:5}} onLock={()=>{ this.alert.onAlert({title:strings.lockProviderInfo, subTitle:strings.lockProviderInfoMoreInfo}) }} viewLock={(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" && this.state.params.driver==true && this.state.deferredPayment==true)} text={this.state.providerLastName} textExplication={strings.lastName} editable={(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" && this.state.params.driver==true && this.state.deferredPayment!=true)} placeholder={example.lastName} onChangeText={(text)=>{this.setState({providerLastName: text,change:true })}} />

              <TextPresentation style={{marginTop:5}} onLock={()=>{ this.alert.onAlert({title:strings.lockProviderInfo, subTitle:strings.lockProviderInfoMoreInfo}) }} viewLock={(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" && this.state.params.driver==true && this.state.deferredPayment==true)} text={(this.state.providerEnterprise!=undefined)?this.state.providerEnterprise:""} textExplication={strings.enterprise} editable={(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" && this.state.params.driver==true && this.state.deferredPayment!=true)} placeholder={example.company} onChangeText={(text)=>{this.setState({providerEnterprise: text,change:true })}} suggestions={(info.countryCode=="fr")?"enterprise":undefined} onSuggestion={(value)=>{ this.setState({providerEnterprise: value.name, change:true }) ; if(this.state.providerBill==true && this.state.deferredPayment!=true) this.setState({providerAdressBill:value.adress, providerCityBill:value.city }) }} />

              {(this.state.providerBill==true && this.state.deferredPayment!=true) && <TextPresentation style={{marginTop:5}} text={(this.state.providerAdressBill!=undefined)?this.state.providerAdressBill:""} textExplication={strings.adress} editable={(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" && this.state.params.driver==true)} placeholder={example.enterprise} onChangeText={(text)=>{this.setState({providerAdressBill: text,change:true })}} />}

              {(this.state.providerBill==true && this.state.deferredPayment!=true) && <TextPresentation style={{marginTop:5}}  text={(this.state.providerCityBill!=undefined)?this.state.providerCityBill:""} textExplication={strings.city} editable={(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" && this.state.params.driver==true)} placeholder={example.enterprise} onChangeText={(text)=>{this.setState({providerCityBill : text,change:true })}} />}

          </TextPresentation>}


          {this.state.letaxiProvider==true && <TextPresentation style={{marginTop:5}} icon={(style.mode=="light")?require('../assets/letaxi_black.png'):require('../assets/letaxi_white.png')}   text={"Le.taxi"} textExplication={strings.provider} editable={false} />}

          {(this.state.karhooProvider==true && (this.state.driver==true || this.state.viewKarhooForDrivers==true)) && <TextPresentation style={{marginTop:5}} icon={(style.mode=="light")?require('../assets/logo_karhoo_black.png'):require('../assets/logo_karhoo_white.png')}   text={(this.state.karhooAccountID!=undefined && karhooPartner[this.state.karhooAccountID]!=undefined)?karhooPartner[this.state.karhooAccountID].name:"Karhoo"} textExplication={(this.state.karhooAccountID!=undefined && karhooPartner[this.state.karhooAccountID]!=undefined)?"KARHOO":strings.provider} editable={false}  
            elementRight={(this.state.karhooAccountID!=undefined && karhooPartner[this.state.karhooAccountID]!=undefined && karhooPartner[this.state.karhooAccountID].sla!=undefined)?<TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => { this.alert.onAlert({title:karhooPartner[this.state.karhooAccountID].name, subTitle:karhooPartner[this.state.karhooAccountID].sla.fr }) }}> 
                        <View style={{flexDirection:"row", }} >
                          <Image source={require('../assets/iconi_red.png')} style={{height:13,width:13,resizeMode:"contain", }}/>
                          <Text style={{marginLeft:2, color: style.colorNotification,fontSize: style.textInputFontSize*0.9,textAlign: "center",fontWeight: 'bold'}}>{strings.conditions}</Text>
                        </View>
                      </TouchableHighlight>:undefined}

          />}


          {(this.state.numFlight!=undefined && this.state.numFlight!="")  && <FlightInfo style={{marginTop:15, marginBottom:10, marginLeft:"5%", marginRight:"5%"}} raceDate={this.state.raceDate} start={this.state.racePlaceStartName} end={this.state.racePlaceEndName} textInputFlex={2} numero={this.state.numFlight}  editable={(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" &&  (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance"))  ))} onChangeNumber={(text)=>{this.setState({numFlight: text,change:true }) }} />}

          {(this.state.numTrain!=undefined && this.state.numTrain!="" && this.state.numTrainGeoloc==undefined)  && <SncfInfo  raceDate={this.state.raceDate} textInputFlex={2} numero={this.state.numTrain}  editable={(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" &&  (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance"))  ))} onChangeNumber={(text)=>{this.setState({numTrain: text,change:true }) }} />}

          {(this.state.numTrain!=undefined && this.state.numTrain!="" && this.state.numTrainGeoloc!=undefined) && <SncfInfo typeTrajet={((this.state.numTrainGeolocEnd==true)?"departures":"arrivals")} raceDate={(this.state.numTrainGeolocEnd==true)?(this.state.raceDate+this.state.estimateTimeValue*1000):this.state.raceDate} stationPosition={this.state.numTrainGeoloc} textInputFlex={2} numero={this.state.numTrain}  editable={(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" &&  (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance"))  ))} onChangeNumber={(text)=>{this.setState({numTrain: text,change:true }) }} />}





          <TextPresentation style={{marginTop:5}} icon={(style.mode=="light")?require('../assets/calendar_black.png'):require('../assets/calendar_white.png')}   textExplication={strings.race} text={((new Date(this.state.raceDate).getDate()<10)?"0":"")+new Date(this.state.raceDate).getDate()+" "+strings.monthList[new Date(this.state.raceDate).getMonth()].toLowerCase()} editable={false}  
                   viewEdit={(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance"))  ) )}   onEditClick={()=>{ if(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance"))  ) ) {this.setState({changeDateDuplicate:false});this.selectDate.onPicker(new Date(this.state.raceDate)) }; }}
                   elementRight={ <View style={{flexDirection:"row", }} >
                        {this.state.racePlaceEndNameTest!=undefined && <Image source={(style.mode=="light")?require('../assets/futureRace_black.png'):require('../assets/futureRace_white.png')} style={{height:13,width:13,resizeMode:"contain", }}/>}
                        {this.state.racePlaceEndNameTest!=undefined && <Text style={{marginLeft:2, color: style.textInputColor,fontSize: style.textInputFontSize*0.9,textAlign: "center",fontWeight: 'bold'}}>{this.state.estimateKm}</Text>}

                        {this.state.racePlaceEndNameTest!=undefined && <Image source={(style.mode=="light")?require('../assets/waiting_black.png'):require('../assets/waiting_white.png')} style={{marginLeft:5, height:13,width:13,resizeMode:"contain", }}/>}
                        {this.state.racePlaceEndNameTest!=undefined && <Text style={{marginLeft:2,color: style.textInputColor,fontSize: style.textInputFontSize*0.9,textAlign: "center",fontWeight: 'bold'}}>{(Math.floor(this.state.estimateTimeValue/3600)<10?"0":"")+Math.floor(this.state.estimateTimeValue/3600)+":"+((Math.floor((this.state.estimateTimeValue-3600*Math.floor(this.state.estimateTimeValue/3600))/60)<10)?"0":"")+Math.floor((this.state.estimateTimeValue-3600*Math.floor(this.state.estimateTimeValue/3600))/60) }</Text>}



                    </View> }


          />

          <View style={{marginLeft:'5%', marginRight:'5%',marginTop:15,}} > 
              <RaceTrajetInfo letaxiProvider={this.state.letaxiProvider} changeDuration={this.changeDuration} addStopAutorization={(this.state.status!="waiting" && this.state.racePlaceEndNameTest!="" && (this.state.stopList==undefined || this.state.stopList.length<5) && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance") )  ) )} raceDate={this.state.raceDate} goReturnTaxi={this.state.goReturnTaxi} estimateTimeValue={this.state.estimateTimeValue} racePlaceEndName={this.state.racePlaceEndName} onPricePlaceFrom={this.onPricePlaceFrom} onPricePlaceTo={this.onPricePlaceTo} onPricePlaceStop={this.onPricePlaceStop} stopList={this.state.stopList} racePlaceStartName={this.state.racePlaceStartName} raceDate={this.state.raceDate} disable={!(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance") )  ))} /> 
          </View>
 


        {(this.state.racePlaceEndNameTest!="" && this.state.racePlaceEndNameTest!=undefined && Platform.OS!="web") && <View>

        <MapView region={this.state.regionZoom} style={{alignSelf: 'stretch',width: Dimensions.get('window').width, height:200,marginTop:15}}>
            {(this.state.driverPosition.latitude!=undefined) && <MapView.Marker coordinate={this.state.driverPosition} > 
              <Image source={require('../assets/car.png')} style={{height:30,width:15}}/> 
            </MapView.Marker>}

            {this.state.markers.map(marker => (<MapView.Marker coordinate={marker} style={{width:(marker.destination==true)?16:18, height:(marker.destination==true)?16:18,}} > 
                <View style={{width:(marker.destination==true)?16:18, height:(marker.destination==true)?16:18, backgroundColor:style.color1, borderRadius:(marker.destination==true)?undefined:9, transform: [{ rotate: (marker.destination==true)?"45deg":"0deg" }] }}/>

              </MapView.Marker> ))}
            <MapView.Polyline coordinates={[...this.state.coords]} strokeWidth={3} strokeColor={style.color1} />

        </MapView>

        <TouchableHighlight underlayColor={style.backgroundColor} onPress={() => { 

            this.alert.onAlert({title:strings.navigation,subTitle:strings.preferGmapWaze,buttons:[
              {text: "Google Maps",onPress: () => {
                  var adre=(this.state.racePlaceEndName!=undefined)?(this.state.racePlaceEndName+"&waypoints="+this.state.racePlaceStartName):this.state.racePlaceStartName; 
                  Linking.openURL("https://www.google.com/maps/dir/?api=1&destination="+adre)
              }},
              {text: "Waze",onPress: () => {Linking.openURL('waze://?q='+this.state.racePlaceStartName+'&navigate=yes') }},
              {text: strings.cancel, style:"cancel",onPress: () => {}}
              ],});

         }} style={{width:32, height:32, marginTop:20, right:5, borderRadius:16, backgroundColor:style.backgroundColor,shadowOpacity: 0.3,shadowRadius: 2,shadowOffset: {height: 0,width: 0},elevation: 1, position:"absolute", alignItems:"center",justifyContent:"center"}}>
            <Image source={(style.mode=="light")?require('../assets/preview_black.png'):require('../assets/preview_white.png')} style={{height:20,width:20,resizeMode:"contain",}}/>
                            
        </TouchableHighlight>

        </View>}


        {this.state.letaxiProvider!=true && <TextPresentation style={{marginTop:5}} icon={(this.state.status=="invoiced" || this.state.status=="finish" || this.state.paymentDriverMode=="onlyDriver" || this.state.paymentDriverMode=="driverAndClient")? ((style.mode=="light")?require('../assets/revenue_change_black.png'):require('../assets/revenue_change_white.png')) : ((this.state.deferredPayment==true || this.state.karhooProvider==true || this.state.alreadyPaid==true)?((style.mode=="light")?require('../assets/waiting_black.png'):require('../assets/waiting_white.png')): ( (this.state.charge==undefined && this.state.withMyPOS!=true)?(style.mode=="light")?require('../assets/payOnBoard_black.png'):require('../assets/payOnBoard_white.png'): ((style.mode=="light")?require('../assets/cardCB_black.png'):require('../assets/cardCB_white.png')) ))}   textExplication={((this.state.status=="invoiced" || this.state.status=="finish")?strings.amount:( (this.state.paymentDriverMode=="onlyDriver" || this.state.paymentDriverMode=="driverAndClient")?(strings.billTo+" : "+this.state.providerName+" "+this.state.providerLastName)     :((this.state.withMyPOS==true)?"MyPOS":( ((this.state.deferredPayment==true || this.state.karhooProvider==true)?strings.deferredPaymentRace:((this.state.charge==undefined && this.state.alreadyPaid!=true)?strings.notpaid: (  strings.alreadyPaid+((this.state.charge!=undefined && this.state.charge.capture==="stripeError")?" : "+this.state.charge.creditAmount+"€":"")  ) )) ) ) ))} text={(this.state.hideDriverPrice!=true || this.state.taxiMode==true || this.state.driver==true)?this.state.estimatePrice:this.state.driverPrice} editable={false}  
                   textPrecision={(this.state.hideDriverPrice!=true || this.state.taxiMode==true || this.state.driver==true) && ( ((this.state.driverPlaceInfoAdmin!=undefined && this.state.driverPlaceInfoAdmin!=false && this.state.driverPlaceInfoAdmin!=this.state.estimatePrice) || (this.state.driverPrice!=undefined && this.state.driverPrice!=this.state.estimatePrice)) )?(" ("+strings.partner.toLowerCase()+" : "+((this.state.driverPlaceInfoAdmin!=undefined && this.state.driverPlaceInfoAdmin!=false)?this.state.driverPlaceInfoAdmin:this.state.driverPrice)+")"):undefined}
                   viewEdit={(this.state.status=="validate" && this.state.raceProviderMode!=true && this.state.driver==true)}   onEditClick={()=>{ if(this.state.status=="validate" && this.state.raceProviderMode!=true && this.state.driver==true)  this.changePriceClient(); }}
                   enableInfo={!(this.state.status=="invoiced" || this.state.status=="finish" || this.state.paymentDriverMode=="onlyDriver" || this.state.paymentDriverMode=="driverAndClient")} onInfo={()=>{this.paiementExplication() }}
        />}



        <TextPresentation style={{marginTop:0}} icon={(style.mode=="light")?require('../assets/partner_dark.png'):require('../assets/partner_light.png')}  textMini={(this.state.viewD==true && this.state.status=="validate" && this.state.driver==true)?strings.seeByDriver:undefined} textExplication={strings.attributedPartner} text={(this.state.attributedPartner.text.length>23)?(this.state.attributedPartner.text.substring(0,21)+"..."):this.state.attributedPartner.text} editable={false}  
                   viewEdit={(this.state.status=="validate" && this.state.raceProviderMode!=true && this.state.driver==true && this.state.letaxiProvider!=true)}   onEditClick={()=>{ if(this.state.status!="waiting" && this.state.status!="cancel" && this.state.status!="invoiced" && this.state.status!="finish" && (this.state.params.driver==true || (this.state.params.partner==true && this.state.privilegeDriver=="max") )  ) {if(this.state.raceInProgress==true)  this.alert.onAlert({title:strings.raceInProgress, subTitle:strings.changeDriverRaceInProgress }); else this.viewPartner()  }} }
                  elementRight={(this.state.purposeChange==true)?<MavButton onlyButton={true} small={true} text={strings.alertModif} onPress={()=>{ this.alertModif() }} />: ((this.state.desiredDriver!=undefined && this.state.desiredDriver.id!=undefined && this.state.letaxiProvider!=true) ? <View style={{flexDirection:"row", }} >
                              <Text style={{marginLeft:2, color: style.textInputColor,fontSize: style.textInputFontSize*0.65,textAlign: "right",}}>{strings.desiredDriver+"\n"+this.state.desiredDriver.text}</Text>
                            </View>:undefined)}
        />


        {(this.state.driverMessage!=undefined && this.state.driver==true) && <TextPresentation hideTopbar={true} style={{marginTop:5}} defautVisible={true} text={ ""  } >
                  
                  {Object.keys(this.state.driverMessage).map((rowData,id) => (<View> 

                          <View style={{marginLeft:'5%', marginRight:'5%', width:"90%", marginTop:10, justifyContent:"space-between", flexDirection:"row", alignItems:"center",  }} >
                              
                              <View style={{ width:"80%"}}>
                                  <Text style={{color: style.textInputColor,fontStyle: 'italic',fontSize: style.textInputFontSize*0.75,textAlign: "left",}}>{strings.message.toUpperCase() +" (" + ( (new Date(parseInt(rowData)).getDate()<10)?"0":"" )+ new Date(parseInt(rowData)).getDate()+"/"+((new Date(parseInt(rowData)).getMonth()<9)?"0":"" )+ (new Date(parseInt(rowData)).getMonth()+1)+" - "+((new Date(parseInt(rowData)).getHours()<10)?"0":"" )+ new Date(parseInt(rowData)).getHours()+":"+((new Date(parseInt(rowData)).getMinutes()<10)?"0":"" )+ new Date(parseInt(rowData)).getMinutes()+")" }</Text>
                                  <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize, textAlign: "justify",}}>{this.state.driverMessage[rowData].text }</Text>
                              </View>

                              <MavMiniButton  minimize={true} icon={(style.mode=="dark")?require('../assets/driver_bin_dark.png'):require('../assets/driver_bin_light.png')} text={strings.remove} onlyButton={true}  onPress={()=>{ 
                                  const fireInfo={} 
                                  fireInfo['race/' + this.state.id+"/driverMessage/"+rowData]=null
                                  update(ref(getDatabase(firebase)), fireInfo)
                                  var driverMessage=JSON.parse(JSON.stringify(this.state.driverMessage));
                                  delete driverMessage[rowData]
                                  this.setState({driverMessage:driverMessage}); 
                                }} />
                          </View>
                          {(id<Object.keys(this.state.driverMessage).length-1) && <View style={{height: style.textLineHeight,backgroundColor: style.textInputLineColor, marginTop: 5,marginLeft:10,marginRight:10}}/>}
                      </View>
                  ))}
        </TextPresentation>}




        {(this.state.car!=undefined) && <TextPresentation style={{marginTop:0}} icon={(style.mode=="light")?require('../assets/carFront_black.png'):require('../assets/carFront_white.png')}   textExplication={strings.car} text={this.state.car.brand+" "+this.state.car.model} editable={false}  
                viewEdit={(this.state.attributedPartner.id==getAuth(firebase).currentUser.uid && this.state.status!="waiting" && this.state.status!="cancel" && this.state.status!="invoiced" && this.state.status!="finish" )}   onEditClick={()=>{ if(this.state.attributedPartner.id==getAuth(firebase).currentUser.uid && this.state.status!="waiting" && this.state.status!="cancel" && this.state.status!="invoiced" && this.state.status!="finish" ) this.viewCar()  }}
                elementRight={(this.state.letaxiProvider!=true)?<TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => { if(this.state.driver==true && this.state.status!="waiting" && this.state.status!="cancel" && this.state.status!="invoiced" && this.state.status!="finish") this.changeCarName() }}>
                          <View style={{flexDirection:"row", alignItems:"center" }} > 
                            {(this.state.driver==true && this.state.status!="waiting" && this.state.status!="cancel" && this.state.status!="invoiced" && this.state.status!="finish") && <Image source={(style.mode=="dark")?require('../assets/edit_white.png'):require('../assets/edit_black.png')} style={{height:8,width:8,marginRight:2, resizeMode:"contain"}}/>}
                            <Text style={{marginLeft:2, color: style.textInputColor,fontSize: style.textInputFontSize*0.9,textAlign: "center",}}>{this.state.carName}</Text>
                          </View>

                      </TouchableHighlight>:undefined
          }/>}

          < ManageOptions money={this.state.money} disableChange={!(this.state.status=="validate" && (this.state.driver==true || (this.state.partner==true && (this.state.privilegeDriver=="avance" || this.state.privilegeDriver=="max" ))))} selectedOptions={this.state.selectedOptions} onSelectedOption={(name, value, price)=>{ this.changeSelectedOptions(name,value, price);  }}  style={{marginTop:5}} />

          <TextPresentation style={{marginTop:5}} icon={(this.state.description=="" || this.state.description==undefined)?require('../assets/description_grey.png'):((style.mode=="light")?require('../assets/description_black.png'):require('../assets/description_white.png'))}  reduceTextSize={true} noAvailable={(this.state.description=="" || this.state.description==undefined)?true:undefined} multiline={true} disableChild={!(this.state.status!="waiting" && this.state.status!="cancel" && this.state.status!="invoiced" && this.state.status!="finish" )} textExplication={strings.description} text={(this.state.description=="" || this.state.description==undefined)?strings.userNoDescription:( (this.state.viewEditDescription==true && this.state.description.length>30)?(this.state.description.substring(0,30)+"..."):this.state.description)} editable={false}    >
              
                <TextPresentation text={this.state.description} multiline={true} textExplication={strings.description} editable={(this.state.status!="waiting" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance"))  ) )} placeholder={strings.userNoDescription} onChangeText={(text)=>{this.setState({description: text,change:true })}}/>

                {(this.state.numTrain==undefined && this.state.numFlight==undefined) && <TouchableHighlight style={{marginTop:35}} underlayColor={'#FFFFFF00'} onPress={() => { this.addTrainFlight("train"); }}>
                    <Text style={{textDecorationLine:'underline',marginLeft:"5%",  color: style.textInputColor,fontSize: style.textInputFontSize}}>{strings.addNumTrain}</Text>
                </TouchableHighlight>}

                {(this.state.numTrain==undefined && this.state.numFlight==undefined) && <TouchableHighlight underlayColor={'#FFFFFF00'} style={{marginTop:10}} onPress={() => { this.addTrainFlight("flight"); }}>
                    <Text style={{textDecorationLine:'underline',marginLeft:"5%",  color: style.textInputColor,fontSize: style.textInputFontSize}}>{strings.addNumFlight}</Text>
                </TouchableHighlight>}

          </TextPresentation>








          {(this.state.status!="waiting" && this.state.raceProviderMode!=true && (Platform.OS!="web" || this.state.raceInProgress==true)   && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel")  && <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => {this.liveRaceGestion(); }}>


               <Animated.View style={{ width:"90%", marginTop:40, height:50, marginLeft:"5%", borderRadius:25, shadowOpacity: 1, shadowColor:(this.state.raceInProgress=="pause")?style.colorWaiting:((this.state.raceInProgress==true)?style.colorNotification:style.colorValidate), shadowRadius: this.shadowStartButton,shadowOffset: {height: 0,width: 0},elevation: 1}}>
                  <View style={{width:"100%", borderRadius:25, height:50, position:"absolute", backgroundColor:style.backgroundColorContrast, justifyContent:"center", }} />
                  <Animated.View style={{width:"100%", borderRadius:25, height:50, position:"absolute", backgroundColor:"#FFFFFF", opacity:this.opacityStartButton,}}/>
                  
                  <View style={{marginLeft:60, borderRadius:25, height:50, position:"absolute", alignItems:"center", justifyContent:"center", }}>
                      <Text style={{marginLeft:-2,color: style.textInputColor,fontSize: style.textInputFontSize*1.2,fontWeight: 'bold',}}>{(this.state.raceInProgress=="pause")?strings.restartPause:((this.state.raceInProgress==true)?strings.cancelRaceNow:strings.startRaceNow)}</Text>
                  </View>
                                              
                  <View style={{position:"absolute"}}>
                     <Animated.View style={{backgroundColor:(this.state.raceInProgress==true)?"#D15638":"#96D35F", opacity:this.opacityStartButton, position:"absolute", width:50, height:50, borderRadius:25 }} />

                    <View style={{backgroundColor:(this.state.raceInProgress=="pause")?style.colorWaiting:((this.state.raceInProgress==true)?style.colorNotification:style.colorValidate), width:50, height:50, borderRadius:25, alignItems:"center", justifyContent:"center",  }} >
                      <Image source={(this.state.raceInProgress=="pause")?(style.mode=="dark")?require('../assets/playPause_white.png'):require('../assets/playPause_black.png'): ((this.state.raceInProgress==true)?(style.mode=="dark")?require('../assets/close_white.png'):require('../assets/close_black.png'):((style.mode=="dark")?require('../assets/futureRace_white.png'):require('../assets/futureRace_black.png'))) } style={{height:(this.state.raceInProgress==true || this.state.raceInProgress=="pause")?25:35,width:(this.state.raceInProgress==true || this.state.raceInProgress=="pause")?25:35,resizeMode:"contain",}}/>
                                  
                    </View>
                  </View>

              </Animated.View>
          </TouchableHighlight>}





        
        {(this.state.raceProviderMode!=true && this.state.status!="waiting" && this.state.removeOption!=true) && <TextPresentation style={{marginTop:30}} iconCircle={true} iconCircleColor={style.backgroundColorContrast}  icon={(style.mode=="dark")?require('../assets/tools_white.png'):require('../assets/tools_black.png')} text={strings.tools}   >
                  <View style={{width:10, height:10}} />
                
                  {(this.state.status!="waiting" && this.state.karhooProvider!=true && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" && info.trackLink!=undefined && (this.state.providerID!=undefined || this.state.customerPro==true) && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance") ) ))  &&  <TextPresentation iconCircle={true}  onEditClick={()=>{this.viewQRCode() }} backgroundColor={style.backgroundColorContrast} textInputFlex={2} textExplication={strings.trackLink} icon={(style.mode=="dark")?require('../assets/route_dark.png'):require('../assets/route_light.png')} disabledText={true}/>}
                  {(this.state.status!="waiting" && this.state.raceProviderMode!=true && this.state.status!="invoiced" && this.state.status!="cancel" && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="standard" || this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance")  )  ))  && <TextPresentation onEditClick={()=>{this.viewCancelRace() }}  iconCircle={true} backgroundColor={style.backgroundColorContrast} textInputFlex={2} textExplication={strings.cancelRace} icon={(style.mode=="dark")?require('../assets/driver_cancel_dark.png'):require('../assets/driver_cancel_light.png')} disabledText={true}/> }
                  {(this.state.status!="waiting" && this.state.karhooProvider!=true && this.state.raceProviderMode!=true && this.state.status!="invoiced" && this.state.params.driver==true && this.state.saveRemovedRace==true)  && <TextPresentation onEditClick={()=>{this.viewRemoveRace() }} iconCircle={true} textExplication={strings.removeRace} icon={(style.mode=="dark")?require('../assets/driver_bin_dark.png'):require('../assets/driver_bin_light.png')} disabledText={true}/>}
                  {(this.state.status!="waiting" && this.state.raceProviderMode!=true && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.viewPhone=="always" || (this.state.viewPhone=="onlyManualClient" && (this.state.customerPro==true || this.state.providerID!=undefined)) ))  ) )  &&  <TextPresentation onEditClick={() => { this.exportToAgenda()}} iconCircle={true} textExplication={strings.exportToAgenda} icon={(style.mode=="dark")?require('../assets/calendar_black.png'):require('../assets/calendar_white.png')} disabledText={true}/>}
                  {(this.state.status!="waiting" && (this.state.raceInProgress!=true || this.state.status!="validate") && this.state.karhooProvider!=true && this.state.status!="cancel" && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.privilegeDriver=="max" || this.state.privilegeDriver=="avance") ) ))  && <TextPresentation onEditClick={() => {this.duplicateRace()}} iconCircle={true} textExplication={strings.duplicateRace} icon={(style.mode=="dark")?require('../assets/copy_dark.png'):require('../assets/copy_light.png')} disabledText={true}/>}
                  {(this.state.status!="waiting" && this.state.raceProviderMode!=true && Platform.OS!="web" && info.countryCode!="ma" && info.countryCode!="ch" && this.state.letaxiProvider!=true) && <TextPresentation onEditClick={()=>{this.viewTheBDC() }} iconCircle={true} textExplication={strings.viewBDC} icon={(style.mode=="dark")?require('../assets/driver_bon_dark.png'):require('../assets/driver_bon_light.png')} disabledText={true}/>}
                  {(this.state.status!="waiting" && this.state.raceProviderMode!=true && Platform.OS!="web" && this.state.driver!=true) && <TextPresentation onEditClick={()=>{this.sendMessageToAdmin() }} iconCircle={true} textExplication={strings.sendCommentAdmin} icon={(style.mode=="dark")?require('../assets/request_black.png'):require('../assets/request_white.png')} disabledText={true}/>}
                  {(this.state.status!="waiting"  && this.state.raceProviderMode!=true && this.state.status!="cancel" && (this.state.taxiMode!=true || info.billForTaxi==true) && info.disableBill==false && (info.disableBillForBasic!=true || this.state.privilegeDriver!="basic" || this.state.driver==true) && !(this.state.status=="invoiced" && this.state.karhooProvider==true) && !(this.state.status=="invoiced" && this.state.notBill==true) &&  !(this.state.status=="invoiced" && this.state.deferredPayment==true  && this.state.deferredPaymentID==undefined)) && <TextPresentation onEditClick={()=>{this.viewBillGestion() }} iconCircle={true} textExplication={(this.state.status!="invoiced"  )?strings.generateBill:strings.downloadBill} icon={(style.mode=="dark")?require('../assets/driver_pay_dark.png'):require('../assets/driver_pay_light.png')} disabledText={true}/>}

        </TextPresentation>}

        
        {(this.state.status!="waiting" && this.state.raceProviderMode!=true && this.state.removeOption!=true &&  (this.state.karhooProvider!=true || this.state.params.driver==true || (this.state.params.partner==true && (this.state.viewPhone=="always" || (this.state.viewPhone=="onlyManualClient" && (this.state.customerPro==true || this.state.providerID!=undefined)) ) )) ) && <TextPresentation style={{marginTop:30}} iconCircle={true} iconCircleColor={style.backgroundColorContrast} icon={(style.mode=="dark")?require('../assets/contact_white.png'):require('../assets/contact_black.png')} text={strings.contact} maxiMode={"partial"} >
                <View style={{width:10, height:10}} />
                
                {(this.state.providerID==undefined && this.state.letaxiProvider!=true && this.state.karhooProvider!=true && this.state.viaAPI!=true && this.state.customerPro!=true && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" &&  (this.state.attributedPartner!=undefined && this.state.attributedPartner.id==getAuth(firebase).currentUser.uid) )  && <TextPresentation onEditClick={()=>{this.viewSeeChat() }} iconCircle={true} textExplication={strings.seeChat} icon={(style.mode=="dark")?require('../assets/chat_black.png'):require('../assets/chat_white.png')} disabledText={true}/>}
                {(this.state.karhooProvider!=true  && Platform.OS!="web" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.viewPhone=="always" || (this.state.viewPhone=="onlyManualClient" && (this.state.customerPro==true || this.state.providerID!=undefined)) ) )))  && <TextPresentation onEditClick={()=>{this.sendImCommingMessage() }} iconCircle={true} textExplication={strings.SMSImComming} icon={(style.mode=="dark")?require('../assets/driver_message_dark.png'):require('../assets/driver_message_light.png')} disabledText={true}/>}
                {(this.state.karhooProvider!=true && Platform.OS!="web" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.viewPhone=="always" || (this.state.viewPhone=="onlyManualClient" && (this.state.customerPro==true || this.state.providerID!=undefined)) ))))  && <TextPresentation onEditClick={()=>{this.sendImHereMessage() }} iconCircle={true} textExplication={strings.SMSImHere} icon={(style.mode=="dark")?require('../assets/home_dark.png'):require('../assets/home_light.png')} disabledText={true}/>}
                {(this.state.clientPhone!=undefined && Platform.OS!="web" && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.viewPhone=="always" || (this.state.viewPhone=="onlyManualClient" && (this.state.customerPro==true || this.state.providerID!=undefined)) ) ))) && <TextPresentation onEditClick={()=>{Linking.openURL("tel:"+this.state.clientPhone);  }} iconCircle={true} textExplication={strings.callCustomer} icon={(style.mode=="dark")?require('../assets/driver_phone_dark.png'):require('../assets/driver_phone_light.png')} disabledText={true}/>}
                {(this.state.karhooProvider!=true && this.state.raceProviderMode!=true && Platform.OS!="web" && this.state.status!="invoiced" && this.state.status!="finish" && this.state.status!="cancel" && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.viewPhone=="always" || (this.state.viewPhone=="onlyManualClient" && (this.state.customerPro==true || this.state.providerID!=undefined)) ))  ) )  && <TextPresentation onEditClick={()=>{this.sendRaceToPartner() }} iconCircle={true} textExplication={strings.sendToFriend} icon={(style.mode=="dark")?require('../assets/partner_dark.png'):require('../assets/partner_light.png')} disabledText={true}/>}
        
        </TextPresentation>}


        {(this.state.driver==true && this.state.removeOption!=true ) && <TextPresentation style={{marginTop:30}} iconCircle={true} iconCircleColor={style.backgroundColorContrast} icon={(style.mode=="dark")?require('../assets/user_manager_white.png'):require('../assets/user_manager_black.png')} text={strings.admin} maxiMode={"partial"} >
            <View style={{width:10, height:10}} />
            
            {(this.state.clientPhone!=undefined && Platform.OS!="web" && this.state.status=="waiting" && (this.state.params.driver==true || (this.state.params.partner==true && (this.state.viewPhone=="always" || (this.state.viewPhone=="onlyManualClient" && (this.state.customerPro==true || this.state.providerID!=undefined)) ) ))) && <TextPresentation onEditClick={()=>{Linking.openURL("tel:"+this.state.clientPhone); }} iconCircle={true} textExplication={strings.callCustomer} icon={(style.mode=="dark")?require('../assets/driver_phone_dark.png'):require('../assets/driver_phone_light.png')} disabledText={true}/>}
            {(this.state.clientID!=undefined  && this.state.raceProviderMode!=true && Platform.OS!="web") && <TextPresentation onEditClick={()=>{this.props.navigation.navigate("Account",{adminView:true,disabledChange:true,findClientById:this.state.clientID}) }} iconCircle={true} textExplication={strings.moreInfosAboutCustomer} icon={(style.mode=="dark")?require('../assets/driver_info_dark.png'):require('../assets/driver_info_light.png')} disabledText={true}/>}
            {(this.state.status!="waiting" && this.state.raceProviderMode!=true && Platform.OS!="web" && this.state.status!="cancel" && this.state.params.driver==true )  &&  <TextPresentation onEditClick={()=>{this.generatePDF() }} iconCircle={true} textExplication={strings.generatePDFRecap} icon={(style.mode=="dark")?require('../assets/pdf_black.png'):require('../assets/pdf_white.png')} disabledText={true}/>}
            {(this.state.status!="waiting" && info.mavOffer=="multi" && ((this.state.providerID==undefined && this.state.customerPro!=true) || info.trackLink!=undefined) ) && <TextPresentation onEditClick={()=>{this.seeGlobalChat () }} iconCircle={true} textExplication={strings.seeChat} icon={(style.mode=="dark")?require('../assets/chat_black.png'):require('../assets/chat_white.png')} disabledText={true}/> }
            {( (this.state.status=="invoiced" || this.state.status=="finish") && this.state.raceProviderMode!=true &&  this.state.gmbLink!="") && <TextPresentation onEditClick={()=>{this.sendWithSMS(this.state.gmbLink) }} iconCircle={true} textExplication={strings.sendGMBLink} icon={(style.mode=="dark")?require('../assets/rating_black.png'):require('../assets/rating_white.png')} disabledText={true}/>}
            {(this.state.raceProviderMode!=true && this.state.status!="waiting") && <TextPresentation onEditClick={()=>{this.viewHelpRace() }} iconCircle={true} textExplication={strings.help} icon={(style.mode=="dark")?require('../assets/help_black.png'):require('../assets/help_white.png')} disabledText={true}/>}
            {(this.state.doubt==true) && <TextPresentation onEditClick={()=>{this.viewDoubt() }} iconCircle={true} textExplication={strings.doubtRace} icon={(style.mode=="dark")?require('../assets/question_black.png'):require('../assets/question_white.png')} disabledText={true}/>}
            {(this.state.status!="waiting" && this.state.driver==true && this.state.karhooProvider==true && false) && <TextPresentation onEditClick={()=>{this.sendMessageToKarhoo() }} iconCircle={true} textExplication={strings.sendCommentKarhoo} icon={(style.mode=="dark")?require('../assets/request_black.png'):require('../assets/request_white.png')} disabledText={true}/>}
            {(this.state.status!="waiting" && this.state.driver==true && this.state.karhooProvider==true && this.state.status!="cancel") && <TextPresentation onEditClick={()=>{this.viewNoShowToKarhoo() }} iconCircle={true} textExplication={strings.noShowToKarhoo} icon={(style.mode=="dark")?require('../assets/request_black.png'):require('../assets/request_white.png')} disabledText={true}/>}
            {(this.state.status!="waiting" && this.state.driver==true && this.state.karhooProvider!=true && this.state.status!="cancel" && this.state.status!="invoiced") && <TextPresentation onEditClick={()=>{this.viewGenerateBill() }} iconCircle={true} textExplication={strings.signalNoShow} icon={(style.mode=="dark")?require('../assets/request_black.png'):require('../assets/request_white.png')} disabledText={true}/>}


            <TouchableHighlight underlayColor={'#FFFFFF00'} onPress={() => { Clipboard.setString(this.state.id);this.alert.onAlert({title:strings.copiedClipboard,}) }}>
                    <View>
                        <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize*1,textAlign: "justify",marginLeft:"10%", marginRight:"10%",marginTop:15,}}>{strings.raceProblemID}</Text>
                        <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize*1,textAlign: "left",marginLeft:"10%", marginRight:"10%",fontWeight: 'bold',}}>{this.state.id}</Text>
                        <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize*0.7,textAlign: "justify",textDecorationLine:'underline',marginLeft:"10%", marginRight:"10%",marginBottom:20}}>{strings.raceProblemIDNext}</Text>
                    </View>
            </TouchableHighlight>

        </TextPresentation>}






      

      <View style={{height:50,width:1}}/>

        


        



          <MavSelectDate 
            minDate={(this.state.roundTrip==true && this.state.date!="")?this.state.date:this.state.dateMin}
            maxDate={(this.state.roundTrip==true && this.state.date2!="")?this.state.date2:"2100-01-01"}
        
            onDateChange={dateTxt => { 

                var date=dateTxt;
                date=new Date(date[6]+date[7]+date[8]+date[9]+'-'+date[3]+date[4]+'-'+date[0]+date[1]+'T'+date[13]+date[14]+':'+date[16]+date[17]+':00Z')
                date=Date.parse(date)+date.getTimezoneOffset()*60000;


                if(this.state.changeDateDuplicate==true) this.duplicateRace(dateTxt,date)
                else {
                  if(new Date(date).getDate()!=new Date(this.state.raceDate).getDate()){
                      console.log("on a changé de jour")
                      var r=this.state.searchStat;
                      r();
                  }
                  this.setState({ date: dateTxt,raceDate:date,change:true});
                }
          
            }}

            ref={select => {this.selectDate = select;}}/>

          <MavAlert ref={alert => {this.alert = alert;}}/>
          <MavQRCode ref={qrCode => {this.qrCode = qrCode;}} />


           <Modal
        animationType="none"
        transparent={true}
        visible={this.state.viewDoubt==true}>

            <View style={{height:Dimensions.get('window').height,width:Dimensions.get('window').width,position:"absolute",justifyContent:"center"}}>

                  <TouchableHighlight underlayColor={"rgba(0,0,0,0.5)"} style={{height:Dimensions.get('window').height,width:Dimensions.get('window').width,backgroundColor:"rgba(0,0,0,0.5)",position:"absolute",marginTop:0}} onPress={() => { this.setState({viewDoubt:false}) }}>
                      <View/>
                  </TouchableHighlight>

                  

                 {this.state.doubtInfo!=undefined && <View style={{width:(Dimensions.get('window').width>style.mobileSizeMax)?style.minimizeWidth:(Dimensions.get('window').width*0.8),backgroundColor:style.backgroundColor,position:"absolute",marginLeft:(Dimensions.get('window').width>style.mobileSizeMax)?((Dimensions.get('window').width-style.minimizeWidth)/2):(Dimensions.get('window').width*0.1*((this.state.drawerMini==true)?0.5:1)),shadowOpacity: 0.6,shadowRadius: 2,shadowOffset: {height: 0,width: 0},elevation: 3}}>
                    
                    

                    <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize*1.25,textAlign: "justify",marginLeft:10, marginRight:10, marginTop:10, fontWeight: 'bold',}}>{strings.doubtRace}</Text>
                    <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize*0.7,textAlign: "justify",marginLeft:10, marginRight:10, marginBottom:20}}>{strings.doubtRaceMoreInfo}</Text>
                                  
                    





                    <View style={{flexDirection:"row", alignItems:"center",marginLeft:10, marginRight:10, }} >
                        <Image source={(this.state.doubtInfo.carrier!=undefined)?( (this.state.doubtInfo.carrier.toUpperCase().search("ORANGE")!='-1')?require('../assets/network/orange.png'):( (this.state.doubtInfo.carrier.toUpperCase().search("SFR")!='-1')?require('../assets/network/sfr.png'): ( (this.state.doubtInfo.carrier.toUpperCase().search("FREE")!='-1')?require('../assets/network/free.png'):(this.state.doubtInfo.carrier.toUpperCase().search("BOUYGUES")!='-1')?require('../assets/network/bouygues.png'): ((style.mode=="light")?require('../assets/ip_black.png'):require('../assets/ip_white.png')) ) ) ):(style.mode=="light")?require('../assets/ip_black.png'):require('../assets/ip_white.png')} style={{height:25,width:25,resizeMode:"contain", marginTop:-3, marginRight:6}}/>
                        
                        <View style={{alignItems:"flex-start"}}>
                               <View style={{flexDirection:"row"}}>
                                    <Text style={{color: style.textInputColor,fontStyle: 'italic',fontSize: style.textInputFontSize*0.75,textAlign: "center",}}>{(((this.state.doubtInfo.carrier!=undefined)?this.state.doubtInfo.carrier+" - ":"")+strings.ipAdress).toUpperCase()}</Text>
                              </View>
                              <View>    
                                  <View style={{flexDirection:"row", alignItems:"center", marginTop:-3}}>
                                      <Text style={{marginLeft:-2,color: style.textInputColor,fontSize: style.textInputFontSize*1.15*((this.state.doubtInfo.ip.length>30)?0.8:1),textAlign: "center",}}>{this.state.doubtInfo.ip}</Text>
                                  </View>
                              </View>

                        </View>

                    </View>


                    <View style={{flexDirection:"row", alignItems:"center",marginLeft:10, marginRight:10,marginTop:15 }} >
                        <Image source={(mobileBrand[this.state.doubtInfo.brand.toUpperCase()]!=undefined)?mobileBrand[this.state.doubtInfo.brand.toUpperCase()].icon:( (style.mode=="light")?require('../assets/tablet_black.png'):require('../assets/tablet_white.png') )} style={{height:25,width:25,resizeMode:"contain", marginTop:-3, marginRight:6}}/>
                        
                        
                        <View style={{alignItems:"flex-start"}}>
                               <View style={{flexDirection:"row"}}>
                                    <Text style={{color: style.textInputColor,fontStyle: 'italic',fontSize: style.textInputFontSize*0.75,textAlign: "center",}}>{(this.state.doubtInfo.brand+ ((this.state.doubtInfo.deviceName!=undefined)?(" "+this.state.doubtInfo.model):"" )).toUpperCase()}</Text>
                              </View>
                              <View>    
                                  <View style={{flexDirection:"row", alignItems:"center", marginTop:-3}}>
                                      <Text style={{marginLeft:-2,color: style.textInputColor,fontSize: style.textInputFontSize*1.15,textAlign: "center",}}>{(this.state.doubtInfo.deviceName!=undefined)?this.state.doubtInfo.deviceName:this.state.doubtInfo.model}</Text>
                                  </View>
                              </View>

                        </View>

                    </View>

                    {this.state.doubtInfo.regionZoom!=undefined && <MapView region={this.state.doubtInfo.regionZoom} style={{alignSelf: 'stretch',width: "100%", height:200,marginTop:15}}>
            
                        <MapView.Circle key={"rrrr"}  center={{latitude: this.state.doubtInfo.pos.latitude,longitude: this.state.doubtInfo.pos.longitude}} strokeColor={"rgba(21,162,255,0.2)"} fillColor={"rgba(21,162,255,0.2)"} radius={this.state.doubtInfo.pos.accuracy} />
                        <MapView.Marker coordinate={this.state.doubtInfo.pos} image={require('../assets/pin.png')} style={{height:30,width:30}} />

                    </MapView>}



                    <View style={{width:'100%', alignItems:"center"}}>
                        <MavButton style={{marginTop:15, marginBottom:15}} text={strings.close} onlyButton={true} onPress={()=>{this.setState({viewDoubt:false}) }}/>
                    </View>




                 </View>}

             </View>
        </Modal>



          <Modal
        animationType="slide"
        transparent={false}
        visible={this.state.waitingLink===true}>

            <View style={{alignItems:"center",justifyContent:"center",position: 'absolute',height:Dimensions.get('window').height, width:Dimensions.get('window').width,backgroundColor:style.backgroundColor}}> 
                  <ActivityIndicator style={{marginTop:-100}} size="large" color={style.color1} /> 
                  <Text allowFontScaling={false} style={{fontSize:style.textInputFontSize,marginTop:5,color:style.textInputColor}}>{strings.thankWaiting}</Text>
              </View>

        </Modal>


        
          </ScrollView>}

          {this.state.seeChat!=false && <View style={{width:"100%", height:"100%", position:"absolute" }} >
            <Chat params ={this.state.seeChat}/>
        </View>}

        {this.state.seeHelpRace!=false && <View style={{width:"100%", height:"100%", position:"absolute" }} >
            <HelpRace params ={this.state} modifyRace={this.modifyRaceFromHelp} goBack={this.helpGoBack}/>
        </View>}

        {this.state.seeGenerateBill!=false && <View style={{width:"100%", height:"100%", position:"absolute" }} >
            <GenerateBill params={this.state.seeGenerateBill}    />
        </View>}

        </View>  
          }</StyleContext.Consumer>
    );
  }
} 

export function generateUUID() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}


App.navigationOptions = ({ navigation, screenProps }) => {
  return {
    headerTitle:navigation.getParam('textHeader'),
   headerTintColor: screenProps.headerColor,
    headerStyle: {
      backgroundColor: screenProps.headerBackgroundColor,
    },
  };
};